export default {
  "account-candidate-content": "Take skill assessments and\ndemonstrate your technical skills.",
  "account-organization-title": "Organizations",
  "account-organization-content": "Assess candidates' technical skills and\nmake data-driven decisions.",
  "sign-up-top-title": "Create Codepresso account",
  "account-login": "Log In",
  "account-signup": "Sign Up",
  "account-email": "Email",
  "account-password": "Password",
  "social-title": "Or",
  "social-linkedin": "LinkedIn",
  "social-google": "Google",
  "sign-up-term-content": "By signing up, you agree to our {policy} and {term} and confirm you are at least 16 years old.",
  "common-terms-of-use": "Terms of Use",
  "common-legal-notice": "Legal Notice",
  "common-privacy-policy": "Privacy Policy",
  "common-cookie-policy": "Cookie Policy",
  "sign-up-bottom": "Already have an account?",
  "error-null-email": "You must enter your email address.",
  "error-personal-email": "Personal or temporary email addresses are not accepted.\nPlease enter a work email address.",
  "error-signup-blocked": "You can't sign up with this email address.\nPlease try again, and if the problem persists, please contact support@codepresso.io",
  "error-null-password": "You must enter a password with at least 10 characters.",
  "error-sign-wrong-approach": "Your request was unsuccessful due to an error.\nPlease try again.",
  "error-invalid-email": "Make sure your email address is correct.",
  "error-invalid-password-size": "Your password must be at least 10 characters long.",
  "error-invalid-password": "Your password must contain numbers and both lower and upper case letters.",
  "sign-send-verification-email": "We have sent the verification email.",
  "sign-verify-email-title": "Verify your email\nto begin exploring Codepresso",
  "sign-verify-email-content": "Check the email we sent to '{email}' and follow the instructions. If you didn't get the verification email, click on the button below and we'll resend it to you.",
  "sign-verify-email-resend": "Resend Verification Email",
  "sign-resend-verification-email": "We have resent the verification email.",
  "sign-send-verification-email-delay": "Please wait 30 seconds before attempting to resend the verification email.",
  "sign-up-complete-title": "You're all set",
  "sign-up-complete-content": "The email verification for account '{email}' is complete and you can start using Codepresso from now on.",
  "common-start": "Start",
  "sign-up-fail-title": "Please resend the verification email",
  "sign-up-fail-description": "We couldn't verify your email address because the verification link has expired.",
  "sign-up-error-title": "Due to a technical error, we were unable to verify your email address",
  "sign-up-error-content": "Please click the button in the email and try again.",
  "sign-in-top-title": "Log in to your account",
  "sign-in-bottom": "Don't have an account?",
  "account-find-password": "I forgot my password",
  "error-account-mis-match": "Check your email and password again.",
  "skillCertify-session-expired-title": "Your session has expired, so your answer can't be submitted.",
  "skillCertify-session-expired-description": "Your answers have been saved safely. Please log in again to continue the assessment.",
  "skillCertify-session-expired-save-fail": "We couldn't save your answers, so you weren't taken to the login page. Please try again in a moment.",
  "error-used-email": "This email is already in use.",
  "account-required": "Login required.",
  "account-up-required": "Signup required.",
  "password-change-enter-email": "Enter your email address",
  "password-change-send-mail-content": "You will receive an email to help you reset your password.",
  "password-change-send-mail": "Send Email",
  "password-change-send-success-dot": "We have sent the password reset email.",
  "password-change-send-success": "We have sent the password reset email",
  "password-change-resend-mail-content-1": "Check the email we sent to '{email}' and follow the instructions. ",
  "password-change-resend-mail-content-2": "If you didn't get the password reset email, click on the button below and we'll resend it to you.",
  "password-change-resend-email": "Resend Password Reset Email",
  "password-change-resend-success": "We have resent the password reset email.",
  "password-change-resend-delay": "Please wait 30 seconds before attempting to resend the new password reset email.",
  "password-change-title": "Set up a new password",
  "password-change-content": "Please enter your new password for '{email}' in the box below.",
  "password-change-new-password": "New Password",
  "password-change-confirm-new-password": "Confirm New Password",
  "password-change": "Change Password",
  "error-null-new-password": "You must enter your new password.",
  "error-null-confirm-new-password": "Make sure your new password and new password confirmation match.",
  "error-save-new-password": "We couldn't save your new password because an error occurred.",
  "password-change-success": "You have changed your password",
  "password-change-continue": "The password for the '{email}' account has been changed. \nLog into your Codepresso account to continue.",
  "password-change-login-account": "Log Into My Account",
  "password-change-fail": "Please resend the password reset email",
  "password-change-fail-description": "We couldn't reset your password because the password reset link has expired.    ",
  "register-description": "Hello, {nickName}!\nPlease complete your registration",
  "register-country-select": "Please select a country/region.",
  "register-country-region": "Search by country/region",
  "common-none-search-data": "No results found.",
  "common-next": "Next",
  "register-notifications-main-content": "Would you like to receive email updates on Codepresso's latest content, events, news, features, challenges, and more?",
  "register-notifications-sub-content-1": "I wish to receive Codepresso's updates by email.",
  "common-first-name": "First Name",
  "common-placeholder-first-name": "Enter your first name.",
  "error-first-name": "The first name must be between 1 and 25 characters.",
  "error-invalid-first-name": "Make sure your first name is correct.",
  "common-last-name": "Last Name",
  "common-placeholder-last-name": "Enter your last name.",
  "error-last-name": "The last name must be between 1 and 25 characters.",
  "error-invalid-last-name": "Make sure your last name is correct.",
  "organization-create-title": "Next, please select whether to create an organization",
  "organization-create-option-1": "Create an organization",
  "organization-create-option-2": "Don't create an organization",
  "organization-create-description": "If you create an organization, {username} will be granted the role of Chief Organization Administrator and can begin managing the organization.",
  "common-organization-name": "Organization Name",
  "common-placeholder-organization-name": "Enter your organization name.",
  "error-organization-name": "The organization name must be between 1 and 50 characters.",
  "register-organization-size-title": "Organization Size",
  "register-organization-size-select": "Please select your organization size.",
  "settings-title": "Settings",
  "settings-logout": "Log Out",
  "account-username": "Username",
  "account-organization": "Organization",
  "account-none-organization": "You don't belong to any organization",
  "account-country": "Country/Region",
  "common-save": "Save",
  "account-change-success": "Your account changes have been saved.",
  "account-change-fail": "We couldn't save your account changes.\nPlease try again.",
  "account-valid-name-size": "The username must be between 2 and 25 characters.",
  "settings-account": "Account",
  "settings-notifications": "Notifications",
  "account-delete": "Delete Account",
  "account-my-delete": "Delete My Account",
  "account-delete-agree-title": "Please agree before deleting your account",
  "account-delete-agree-description": "Personally identifiable information will be permanently deleted and some de-identified information may be retained for statistical purposes.\nFor more details, please refer to the {linkDom}.",
  "account-delete-agree-info": "I agree that my personally identifiable information will be permanently deleted and some de-identified information may be retained for statistical purposes.",
  "account-delete-success": "Your account has been deleted.",
  "account-delete-fail": "We couldn't delete your account.\nPlease try again.",
  "account-current-password": "Current Password",
  "error-current-password": "You must enter your current password.",
  "error-password-incorrect": "Make sure current password is correct.",
  "password-saving-success": "Your password changes have been saved.",
  "password-saving-fail": "We couldn't save your password changes.\nPlease try again.",
  "notifications-agree-title": "Get Codepresso Updates",
  "notifications-agree-content": "Stay updated with Codepresso's latest content, events, news, features, challenges and more.",
  "notifications-change-success": "Your notification preferences have been saved.",
  "notifications-change-fail": "We couldn't save your notifications preferences.\nPlease try again.",
  "organization-members-management": "Organization Users Management",
  "account-delete-transfer-of-role-info": "Before deleting your account, please transfer the Chief Organization Administrator role to another organization user.",
  "account-delete-info": "You can delete your account after your subscription has expired.",
  "organization-settings-title": "Organization Settings",
  "organization-create-button": "Create",
  "organization-create-success": "The organization has been created.",
  "organization-create-fail": "We couldn't create the organization.\nPlease try again.",
  "organization-leave": "Leave Organization",
  "organization-my-leave": "Leave My Organization",
  "organization-leave-transfer-of-role-info": "Before leaving the organization, please transfer the Chief Organization Administrator role to another organization user.",
  "organization-leave-info": "You can leave your organization after your subscription has expired.",
  "organization-leave-title": "Are you sure you want to leave the organization?",
  "organization-leave-info-1": "You can no longer use organization-related features of {OrganizationName}.",
  "organization-leave-info-2-prefix": "Type",
  "organization-leave-info-2-suffix": " and the [Leave] button will become active.",
  "organization-leave-button": "Leave",
  "organization-leave-success": "The organization leave request has been successfully completed.",
  "organization-leave-fail": "We couldn't complete your request to leave the organization. \nPlease try again. ",
  "organization-change-success": "Your organization changes have been saved.",
  "organization-change-fail": "We couldn't save your organization changes.\nPlease try again.",
  "organization-Invite-members": "Invite Users",
  "organization-Invite-members-description": "The invitation email will be sent to the email address you entered.",
  "organization-menu-access": "Menu Access",
  "organization-role": "Role",
  "organization-role-select": "Please select a role.",
  "organization-role-administrator": "Administrator",
  "organization-role-administrator-description": "Access granted menu features and view organization information.",
  "organization-member-remove-title": "Are you sure you want to remove this user?",
  "organization-member-remove-success": "The user is successfully removed.",
  "organization-member-add": "Add User",
  "organization-member-add-success": "The user is added.",
  "organization-Invite-members-success": "User invitation has been sent to {Count} user. | User invitations have been sent to {Count} users.",
  "organization-Invite-members-fail": "We couldn't invite {Count} user.\nPlease try again. | We couldn't invite {Count} users.\nPlease try again.",
  "organization-Invite-members-email-error-1": "This email already belongs to an organization.",
  "organization-Invite-members-email-error-2": "This email has already been invited.",
  "organization-Invite-members-email-error-3": "This email has been entered more than once.",
  "organization-Invite-members-menu-access-error": "You must select at least one menu.",
  "organization-member-count": "User | Users",
  "organization-member": "User",
  "organization-role-chief-administrator": "Chief Administrator",
  "organization-invited": "Invited",
  "organization-active": "Active",
  "organization-last-accessed-date": "Last Accessed Date",
  "organization-transfer-of-role-button-1": "Transfer Chief Organization Administrator Role",
  "organization-member-edit": "Edit User",
  "organization-member-delete": "Delete User",
  "organization-member-resend-email-description": "Do you want to resend the invitation email to '{email}'?",
  "organization-member-resend-email-success": "We have resent the invitation email to '{email}'.",
  "organization-member-resend-email-fail": "We couldn't resend the invitation email to '{email}'.\nPlease try again.",
  "organization-transfer-of-role-title": "Please agree before transferring the Chief Organization Administrator role",
  "organization-transfer-of-role-description": "Once the role is transferred, you will become an Organization Administrator and will no longer be able to edit organization information.",
  "organization-transfer-of-role-info": "I agree to the transfer of the Chief Organization Administrator role.",
  "organization-transfer-of-role-button-2": "Transfer Role",
  "organization-transfer-of-role-success": "The Chief Organization Administrator role has been transferred.",
  "organization-transfer-of-role-fail": "We couldn't transfer the Chief Organization Administrator role.\nPlease try again.",
  "organization-member-information": "User Information",
  "organization-member-information-success": "The user information has been saved.",
  "organization-member-information-fail": "We couldn't save the user information.\nPlease try again.",
  "organization-member-delete-title": "Are you sure you want to delete the user?",
  "organization-member-delete-success": "The user has been successfully deleted.",
  "organization-member-delete-fail": "We couldn't delete the user.\nPlease try again.",
  "organization-invite-accept-fail": "We couldn't process your request to join\n{OrganizationName}",
  "organization-invite-accept-fail-content": "We can't accept the invitation because this email belongs to another organization or an error occurred.\nPlease leave your current organization and try again, or ask an administrator to send a new invitation.",
  "organization-invite-accept-success": "You have joined\n{OrganizationName}",
  "organization-invite-accept-success-content": "You can now use organization-related features of {OrganizationName}.",
  "organization-Invite-members-restriction-info": "The Invite Users feature is available on Pro and Enterprise plans.",
  "organization-subscription-management": "Subscription Management",
  "organization-subscription-none-description-1": "There are no active subscription plans yet.",
  "organization-subscription-none-description-2": "Start a subscription to use the service.",
  "organization-subscription-none-button": "View Plans",
  "organization-subscription-label-1": "Subscribed",
  "organization-subscription-label-2": "Payment Required",
  "organization-subscription-label-3": "Cancellation Pending",
  "organization-subscription-label-4": "Ended",
  "organization-subscription-manage": "Manage",
  "organization-subscription-change-payment-method": "Change Payment Method",
  "organization-subscription-coupon-management": "Coupon Management",
  "organization-subscription-applied": "Applied",
  "organization-subscription-cancel-apply": "Cancel Apply",
  "organization-subscription-cancel-subscription": "Cancel Subscription",
  "organization-subscription-change-billing-cycle-button": "Change",
  "organization-subscription-change-payment-method-success": "The payment method change has been completed.",
  "organization-subscription-cancel-subscription-title": "Do you want to cancel your subscription?",
  "organization-subscription-cancel-subscription-description-1": "You can continue using the service until {date} even after cancellation.",
  "organization-subscription-cancel-subscription-description-3": "Creating new assessments and inviting candidates are restricted.",
  "organization-subscription-cancel-subscription-description-4": "Existing assessments and data will be retained.",
  "organization-subscription-cancel-subscription-success": "The subscription cancellation has been completed.",
  "organization-subscription-cancel-subscription-fail": "We couldn't complete the subscription cancellation.\nPlease try again.",
  "organization-subscription-payment-failed": "Payment Failed",
  "organization-subscription-payment-failed-description-1": "Your service will be limited if payment is not completed by {date}.",
  "organization-subscription-payment-failed-description-2": "Retrying automatic payment",
  "organization-subscription-retry-payment": "Retry Payment",
  "organization-subscription-retry-payment-title": "Do you want to retry the payment?",
  "organization-subscription-retry-payment-description": "Payment will be processed immediately using your saved payment method.",
  "organization-subscription-retry-payment-success": "The payment has been completed.",
  "organization-subscription-retry-payment-fail": "We couldn't complete the payment.\nPlease try again.",
  "payment-complete-next-billing-attempt-date": "Next Payment Attempt Date",
  "organization-subscription-cancellation-pending-description": "Available until {date}. \nAfter that, it will automatically end and you will not be charged.",
  "organization-subscription-cancel-cancellation-request": "Cancel Cancellation Request",
  "organization-subscription-cancel-cancellation-request-success": "The cancellation request has been canceled.",
  "organization-subscription-cancel-cancellation-request-fail": "We couldn't cancel the cancellation request.\nPlease try again.",
  "organization-subscription-restart-subscription": "Restart Subscription",
  "organization-subscription-restart-subscription-title": "Do you want to restart your subscription?",
  "organization-subscription-restart-subscription-description-1": "Plan to Restart",
  "organization-subscription-restart-subscription-description-2": "Restarting your subscription will charge your account\nand restore service access.",
  "organization-subscription-restart-subscription-success": "Your subscription has been restarted.",
  "organization-subscription-restart-subscription-fail": "We couldn't restart your subscription.\nPlease try again.",
  "organization-subscription-end-subscription-description": "On Subscription Restart",
  "organization-subscription-contract-information": "Contract Information",
  "organization-subscription-contract-end-date": "Contract End Date",
  "organization-subscription-contract-end-date-description": "After the contract expires, administrator privileges will be removed for all organization administrators except the chief organization administrator.",
  "organization-subscription-payment-method": "Billing Method",
  "organization-subscription-subject-to-contract": "Subject to contract",
  "organization-subscription-renewal-method": "Renewal Method",
  "organization-subscription-negotiation": "Negotiation",
  "organization-subscription-contract-end": "End Contract",
  "organization-subscription-contract-end-description-1": "Contract Ended.",
  "organization-subscription-contract-end-description-2": "To continue using the service, please contact us.",
  "organization-subscription-coupon-management-tab-menu-1": "Available",
  "organization-subscription-coupon-management-tab-menu-2": "Used",
  "organization-subscription-coupon-management-tab-menu-3": "Expired",
  "organization-subscription-coupon-management-count": "00 Coupon | 00 Coupons",
  "organization-subscription-coupon-management-apply-coupon": "Apply Coupon",
  "organization-subscription-coupon-management-none-1": "There are no available coupons yet.",
  "organization-subscription-coupon-management-none-2": "There are no used or expired coupons yet.",
  "organization-subscription-payment-history-count": "Payment | Payments",
  "organization-subscription-payment-history-item": "Item",
  "organization-subscription-payment-history-invoice": "Invoice",
  "organization-subscription-payment-history-none": "There is no payment history yet.",
  "organization-subscription-payment-history-canceled-date": "Refund Processed Date",
  "organization-subscription-payment-history-fully-canceled": "Fully canceled",
  "organization-subscription-payment-history-partially-canceled": "Partially canceled",
  "organization-subscription-change-billing-cycle": "Change Billing Cycle",
  "organization-subscription-change-billing-cycle-title": "Do you want to change the billing cycle?",
  "organization-subscription-current-billing-cycle": "Current Billing Cycle",
  "organization-subscription-change-billing-cycle-description-1": "After Change",
  "organization-subscription-change-billing-cycle-description-2": "Applied from the next payment.",
  "organization-subscription-change-billing-cycle-success": "The billing cycle change has been completed.\nApplied from the next payment.",
  "organization-subscription-change-billing-cycle-fail": "We couldn't complete the billing cycle change.\nPlease try again.",
  "organization-subscription-change-billing-cycle-scheduled-1": "Switching to monthly billing from the next payment",
  "organization-subscription-change-billing-cycle-scheduled-2": "Switching to annual billing from the next payment",
  "organization-subscription-cancel-change": "Cancel Change",
  "organization-subscription-cancel-subscription-description-2": "Only the Chief Administrator can access organization features.",
  "organization-subscription-change-billing-cycle-scheduled-3": "Switching to monthly billing from the next payment attempt",
  "organization-subscription-change-billing-cycle-scheduled-4": "Switching to annual billing from the next payment attempt",
  "organization-subscription-change-billing-cycle-scheduled-5": "Switching to monthly billing when restarting subscription",
  "organization-subscription-change-billing-cycle-scheduled-6": "Switching to annual billing when restarting subscription",
  "organization-subscription-upgrade-plan": "Upgrade Plan",
  "organization-subscription-upgrade-plan-immediately-applied": "Applied immediately.",
  "organization-subscription-upgrade-settlement-details": "Upgrade Settlement Details",
  "organization-subscription-upgrade-subscription-fee-difference": "Subscription fee difference ({date} days remaining)",
  "organization-subscription-upgrade-pro-remaining-amount": "Pro remaining amount",
  "organization-subscription-upgrade-basic-unused-deduction": "Basic unused deduction",
  "organization-subscription-upgrade-difference": "Difference",
  "organization-subscription-upgrade-credit-unit-price-difference": "Charged credit Pro unit-price difference ({count})",
  "organization-subscription-upgrade-credit-difference-tooltip": "Charged credits have different unit prices per plan; this is the difference to align your held charged credits with the Pro unit price.",
  "organization-subscription-upgrade-held-credit-count": "{count} charged credit held | {count} charged credits held",
  "organization-subscription-upgrade-support-discount": "Upgrade support discount (charged credit Pro unit-price difference)",
  "organization-subscription-upgrade-description-1": "Your {count} charged credit will be retained. | Your {count} charged credits will be retained.",
  "organization-subscription-upgrade-description-2": "The Pro plan fee will be charged from the next payment date.",
  "organization-subscription-upgrade-agree-check": "I agree to the payment and {term}.",
  "organization-subscription-upgrade-plan-success": "The plan upgrade has been completed.",
  "organization-subscription-upgrade-plan-fail": "We couldn't complete the plan upgrade.\nPlease try again.",
  "organization-subscription-change-plan": "Change Plan",
  "organization-subscription-change-plan-title": "Do you want to change the plan?",
  "organization-subscription-change-plan-success": "The plan change has been completed.\nApplied from the next payment.",
  "organization-subscription-change-plan-fail": "We couldn't complete the plan change.\nPlease try again.",
  "organization-subscription-change-plan-scheduled": "Switching to the Pro plan when restarting subscription",
  "credit-title": "Remaining credits:",
  "common-contact-us": "Contact Us",
  "credit-banner": "Credits",
  "credit-detail-button": "View Details",
  "credit-management": "Credit Management",
  "credit-history-title": "Credit Transaction History",
  "credit-history-count": "Transaction | Transactions",
  "credit-history-transaction": "Transaction",
  "credit-history-granted": "Granted",
  "credit-history-used": "Used",
  "credit-history-cancelled": "Canceled",
  "credit-history-revoked": "Revoked",
  "credit-history-table-amount": "Amount",
  "credit-history-table-remaining": "Remaining",
  "credit-history-table-related": "Related",
  "credit-history-table-performed-by": "Performed By",
  "credit-history-table-date": "Date",
  "credit-history-table-credit-expiration": "Credit Expiration",
  "credit-history-table-revoked-reason-credit-expiration": "Automatically revoked due to credit expiration",
  "credit-history-table-until": "Until {time}",
  "credit-history-table-revoked-reason-credit-refund": "Revocation due to refund",
  "credit-history-table-usage-details": "Usage Details",
  "credit-history-table-cancellation-details": "Cancellation Details",
  "credit-history-table-usage-details-info": "{count} credit used in total | {count} credits used in total",
  "credit-history-table-cancellation-details-info": "{count} credit cancelled in total | {count} credits cancelled in total",
  "credit-history-table-candidate-credit-count": "{candidateCount} candidate | {candidateCount} candidates",
  "credit-history-table-candidate-credit-count-1": "{creditCount} credit per candidate | {creditCount} credits per candidate",
  "credit-history-table-none-data": "There is no credit transaction history recorded yet.",
  "credit-limit-description": "If you need more credits, please contact us via the {linkDom} menu.",
  "credit-certify-invitation-button": "View Credit Description",
  "credit-certify-invitation-limit": "You can't invite candidates because you don't have enough credits",
  "credit-history-table-none-related": "Deleted Assessment",
  "credit-history-top-up-credits": "Top Up Credits",
  "credit-history-top-up-credits-count": "Credits to Charge",
  "credit-history-top-up-credits-count-error": "Credits must be between 1 and 9,999.",
  "credit-history-top-up-credits-description-1": "Charged credits never expire and are retained even after your subscription ends.\nHowever, they can only be used while your subscription is active.",
  "credit-history-top-up-credits-description-2": "Payment will be processed using the payment method registered in {link}.",
  "credit-history-top-up-credits-agree-check": "I agree to payment/credit usage conditions and {term}.",
  "credit-history-top-up-credits-make-payment": "Pay",
  "credit-history-top-up-credits-success": "The credit top-up has been completed.",
  "credit-history-top-up-credits-fail": "We couldn't complete the credit top-up.\nPlease try again.",
  "credit-history-top-up-credits-restriction-info-1-title": "You can't top up credits because\nthere is no active subscription plan",
  "credit-history-top-up-credits-restriction-info-2-title": "You can't top up credits because\nyour subscription has ended",
  "credit-history-top-up-credits-restriction-info-2-description": "To continue using the service, please restart your subscription.",
  "credit-history-top-up-credits-restriction-info-3-title": "The Enterprise plan can't top up credits",
  "loading": "Loading",
  "loading-title": "Please wait for a moment.",
  "404-title": "Page Not Found",
  "404-content": "The page you requested could not be found. \nPlease make sure the address you entered is correct and try again.",
  "error-button": "Go to Home",
  "500-title": "Internal Server Error",
  "500-content": "The server encountered an unexpected condition that prevented it from fulfilling the request. \nPlease try again later.",
  "400-title": "Our website is currently under maintenance",
  "400-content": "We apologize for any inconvenience this may cause.\nService stabilization and updates are currently underway, and we hope to have you back to normal as soon as possible.",
  "dashboard-back-button": "Back to Dashboard",
  "common-wrong-approach-title": "We're sorry, something went wrong",
  "common-wrong-approach-content": "Please try again in a moment.",
  "common-ok": "OK",
  "learning-no-access-course": "No access to this course",
  "learning-no-access-course-description": "You need to register for a course first to progress through it.",
  "learning-no-access-course-confirm": "Go to Track",
  "learning-exercise-refresh-page": "Refresh the page",
  "learning-exercise-request-fail": "The request failed due to a technical error.\nPlease try refreshing the page again, and if the problem persists, please contact {email}",
  "learning-finished-course": "You have finished this course",
  "learning-finished-course-description": "You can check your results by going back to this track.",
  "learning-back-to-track": "Back to Track",
  "learning-exercise": "Exercise",
  "common-hour": " h",
  "common-min": " min",
  "common-s": " s",
  "common-points": "Points",
  "learning-easy": "Easy",
  "learning-medium": "Medium",
  "learning-hard": "Hard",
  "learning-view-progress": "View Progress",
  "learning-go": "Go",
  "learning-course-outline": "Course Outline",
  "common-description": "Description",
  "learning-out-put": "Output",
  "learning-out-put-none-submit": "Even If there is no output, you can still submit your answer.\nGrading will be based on the written code.",
  "learning-correct-answer": "Correct Answer",
  "learning-preview": "Preview",
  "common-course": "Course",
  "learning-skill-count": "{count} Skill | {count} Skills",
  "learning-exercise-count": "{count} Exercise | {count} Exercises",
  "common-skill": "Skill",
  "learning-none-description": "No description provided.",
  "learning-out-put-info": "This is the output of your code.",
  "learning-error-info": "We found an error in your code.",
  "learning-error-description": "Error Description",
  "learning-submit-answer": "Submit Answer",
  "learning-submit-answer-info": "The answer to this question will be submitted.",
  "learning-exercise-finished": "You have finished this exercise.",
  "learning-exercise-output-description": "View Output Description",
  "learning-output-description": "Output Description",
  "learning-exercise-complete-fail": "You were unable to complete the exercise.\nPlease recheck the code you submitted.",
  "learning-hint-widget-click": "Click here for a hint.",
  "learning-exercise-incorrect-answer": "This is not the correct answer.",
  "learning-correct": "Correct",
  "learning-activity-widget-drop-code-here": "Drop the code here",
  "learning-activity-widget-correct-code-herer": "Correct Code Here",
  "learning-activity-widget-drag-and-drop-code": "Drag and drop the correct code to fill in the blank.",
  "learning-activity-widget-click-code": "Click the correct code to fill in the blank.",
  "learning-activity-widget-drag-and-drop-parts": "Drag and drop the parts of the code to place them in the right order.",
  "learning-activity-widget-click-parts": "Click on the parts of the code to place them in the right order.",
  "learning-chart": "Plots",
  "learning-lnstruction": "Instruction",
  "learning-multiple-choice": "Multiple Choice",
  "learning-short-answer-type": "Short Answer",
  "learning-essay-type": "Essay",
  "learning-answer-placeholder": "Enter your answer.",
  "learning-show-correct-answer": "Show Correct Answer",
  "learning-answer": "Your Answer",
  "learning-annotation-widget-1": "Write your code here",
  "learning-annotation-widget-2": "Do not modify the code below for evaluation purposes",
  "learning-annotation-widget-3": "Given Data",
  "learning-annotation-widget-4": "Fill in the blanks in the given code with the appropriate code",
  "learning-annotation-widget-5": "Refactor the code below to meet given requirements",
  "term-copyright": "ⓒ {year} Codepresso, Inc. All rights reserved. Unauthorized reproduction or distribution of this material is prohibited.",
  "learning-directory-select-files": "Please select a file from the directory.",
  "learning-reset-select-files": "Please select the files to reset",
  "common-reset": "Reset",
  "learning-reset-select-files-success": "The selected files have been reset.",
  "learning-reset-select-files-fail": "We couldn't reset the selected files.\nPlease try again.",
  "learning-open-directory": "Open Directory",
  "learning-close-directory": "Close Directory",
  "learning-my-output": "My Output",
  "learning-correct-output": "Correct Output",
  "learning-front-exercise-delay": "It may take some time to see the preview, depending on your PC environment.",
  "learning-front-exercise-download-fail": "The download of the installation files necessary for the hands-on environment has failed.\nPlease try refreshing the page again, and if the problem persists, please contact support@codepresso.io",
  "learning-reset-editor": "You can reset the editor.",
  "learning-stop-code": "Stop Code",
  "learning-file-count": "{count} File | {count} Files",
  "learning-copy-clipboard": "Copied to the clipboard.",
  "learning-limit-permission-title": "You don't have permission to access this content",
  "learning-limit-permission-description": "Contact us via the {link} menu for permission.",
  "learning-hide-top-bottom-bars": "Hide Top/Bottom Bars",
  "learning-show-top-bottom-bars": "Show Top/Bottom Bars",
  "learning-front-preview-guide": "The updated code has been reflected in the preview.",
  "challenges-title": "Challenge | Challenges",
  "challenges-description": "Get your skill proficiency verified and take a step further by solving various real-world tech challenges.",
  "common-live": "Live",
  "common-upcoming": "Upcoming",
  "common-closed": "Closed",
  "challenges-start-days": "Starts in {day} days",
  "challenges-start-tomorrow": "Starts Tomorrow",
  "challenges-start-today": "Starts Today",
  "challenges-closed-days": "Closed in {day} days",
  "challenges-closed-tomorrow": "Closed Tomorrow",
  "challenges-closed-today": "Closed Today",
  "challenges-entry-complete": "Entry Complete",
  "challenges-participants-count": "{totalCount} Participants",
  "challenges-certificate": "Certificate",
  "common-all": "All",
  "challenges-count": "Challenges",
  "common-filters": "Filters",
  "challenges-none-data": "There are no registered challenges yet.",
  "common-load-more": "Load More",
  "challenges-leaderboard-submitted-questions-showing-participants": "The leaderboard only shows participants who have submitted answers.",
  "common-period": "Period",
  "challenges-join-challenge": "Join Challenge",
  "common-overview": "Overview",
  "challenges-leaderboard": "Leaderboard",
  "common-guidelines": "Guidelines",
  "challenges-winner": "Winner",
  "challenges-final-ranking-info": "Final rankings and scores are displayed after admin grading.",
  "challenges-participant": "Participant",
  "common-delete-member": "Deleted Member",
  "common-score": "Score",
  "challenges-submit-questions": "Submitted Questions",
  "challenges-total-questions": "/ Total Questions",
  "challenges-last-submission": "Last Submission Date",
  "challenges-none-participants-data": "There are no participants yet.",
  "challenges-guidelines": "Challenge Guidelines",
  "challenges-authentication-code-title": "Enter verification code",
  "challenges-authentication-code-description": "Enter the assigned verification code to participate in this challenge.",
  "challenges-authentication-code-placeholder": "Verification Code",
  "challenges-authentication-code-incorrect": "The verification code you entered is incorrect.",
  "challenges-anti-cheating-guidance": "Anti-cheating Guidance",
  "challenges-anti-cheating-info-1": "To ensure fairness and prevent cheating, real-time monitoring and recording is enabled.",
  "challenges-anti-cheating-info-2": "Please be aware that the following behaviors may be considered cheating.",
  "challenges-anti-cheating-screen-exit-detection": "Leaving the screen",
  "challenges-anti-cheating-screen-exit-detection-info-1": "If this happens more than once, you may be disqualified.",
  "challenges-anti-cheating-screen-exit-detection-info-2": "Please note that no disadvantages will be applied due to unavoidable circumstances, such as submitting inquiries or necessary actions during the process. You may proceed with confidence.",
  "challenges-anti-cheating-keyboard-shortcuts-restriction-and-detection": "Attempting to use unauthorized keyboard shortcuts",
  "challenges-anti-cheating-multiple-monitor-restriction-and-detection": "Attempting to use multiple monitors",
  "challenges-anti-cheating-copy-cut-paste-detection": "Copying, cutting and pasting external code",
  "challenges-anti-cheating-face-voice-recording": "In case the camera or microphone settings are changed or disabled",
  "challenges-anti-cheating-face-voice-recording-info-1": "This includes cases where the camera view is obstructed or the candidate can't be clearly identified.",
  "challenges-agree-rules-title": "Please agree to the guidelines before you start",
  "challenges-agree-rules-description": "I agree that I have read and understand the guidelines.",
  "common-agree": "Agree",
  "common-confirm": "Confirm",
  "challenges-proctoring-full-screen-error": "To proceed with the challenge, you must share your entire screen.",
  "challenges-back-to-challenge-detail": "Back to Challenge Section",
  "challenges-finish-challenge-title": "Do you want to finish this challenge?",
  "common-cancel": "Cancel",
  "challenges-finished-title": "Challenge finished",
  "challenges-finished-description": "The challenge time is over. \nThank you for taking the challenge.",
  "common-dashboard": "Dashboard",
  "common-skillCertify": "SkillCertify",
  "common-manageAssessment": "Manage Assessments",
  "common-takeAssessment": "Take Assessments",
  "common-skillMonitor": "SkillMonitor",
  "common-skillAdvance": "SkillAdvance",
  "common-adaptiveLecture": "SkillFit",
  "advance-learn": "Learn",
  "advance-practice": "Practice",
  "common-choose-language": "Choose a Language",
  "dashboard-info-greetings": "Hello,",
  "dashboard-info-nickName": "{name}",
  "common-closed-assessment": "Closed Assessment | Closed Assessments",
  "dashboard-total-assessments": "Total Assessments",
  "dashboard-completed-candidates": "Completed Candidates",
  "dashboard-total-candidates": "Total Candidates",
  "dashboard-completed-learning": "Completed Learning",
  "dashboard-total-learning": "Total Learning",
  "dashboard-learning-points": "Learning Points",
  "dashboard-total-point": "Total",
  "dashboard-completed-practice": "Completed Practice",
  "dashboard-total-practice": "Total Practice",
  "dashboard-completed-assessments": "Completed Assessments",
  "dashboard-created-assessments": "Created Assessments",
  "dashboard-candidates": "Candidates",
  "common-sample": "Sample",
  "skillCertify-none-created-assessment": "There are no created assessments yet.",
  "skillCertify-internal-assessment": "Org Competency Assessments",
  "skillCertify-external-assessment": "External Talent Assessments",
  "dashboard-invited-assessments": "Invited Assessments",
  "dashboard-sample-assessments": "Sample Assessments",
  "skillCertify-none-invited-assessment": "There are no invited assessments yet.",
  "advance-my-learning": "My Learning",
  "advance-my-learning-more": "See My Learning",
  "advance-position-learn": "Learning Position",
  "advance-permission-disable": "You don't have permission to access this content.\nContact Us via the Contact Us menu for permission.",
  "advance-position-info": "Course & Skill Info",
  "advance-learn-none-data": "You haven't started learning yet.",
  "advance-my-practice": "My Practice",
  "advance-my-practice-more": "See My Practice",
  "advance-position-practice": "Practice Position",
  "advance-practice-none-data": "You haven't started practice yet.",
  "advance-find-track": "Explore Tracks",
  "advance-my-learn-sub-description": "An overview of all the learning you have started.",
  "common-in-progress": "In Progress",
  "common-completed": "Completed",
  "filter-field": "Field",
  "filter-select": "{count} Selected",
  "advance-my-practice-sub-description": "An overview of all the practice you have started.",
  "advance-learn-sub-description": "Acquire skills and build your job capabilities to advance your career.",
  "advance-none-track": "There are no registered tracks yet.",
  "advance-practice-sub-description": "Check your skills and job capabilities through practice assessments.",
  "advance-level-count": "{count} Level | {count} Levels",
  "advance-course-count": "{count} Course | {count} Courses",
  "advance-related-practice": "Related Practice",
  "advance-related-practice-info": "Check whether you have understood what you have learned.",
  "common-point-count": "{point} Points",
  "advance-not-start": "Lock",
  "advance-pre-start": "Pre-Start",
  "advance-ongoing": "Ongoing",
  "advance-related-learn": "Related Learn",
  "advance-related-learn-info": "Learn and improve the areas where you're lacking.",
  "advance-my-level": "Lv {level}",
  "skillCertify-manage-assessment-description": "Easily create the customized assessments you need, and easily edit, view, and delete existing assessments.",
  "skillCertify-search-placeholder": "Search by assessment name",
  "common-status": "Status",
  "skillCertify-assessment-count": "Assessment | Assessments",
  "skillCertify-create-assessment": "Create Assessment",
  "common-information": "Information",
  "skillCertify-type": "Type",
  "common-question-info": "Question | Questions",
  "common-question-count": "{count} Question | {count} Questions",
  "common-duration": "Duration",
  "skillCertify-more-information": "More Information",
  "skillCertify-proctoring": "Proctoring",
  "skillCertify-constructor": "Created By",
  "skillCertify-creation-date": "Created On",
  "skillCertify-tracks-settings": "Tracks Settings",
  "skillCertify-assessment-set-title-to-level-plural": "{title} - {level} and {count}",
  "skillCertify-assessment-set-title-to-level-singular": "{title} - {level}",
  "skillCertify-tracks-information-detail": "Tracks Information Details",
  "skillCertify-pre-start": "Pre-Start",
  "skillCertify-invited": "Invited",
  "skillCertify-ready": "Ready",
  "skillCertify-started": "Started",
  "skillCertify-completed": "Completed",
  "skillCertify-view-actual-question": "View Actual Questions",
  "skillCertify-actual-question": "Actual Questions",
  "skillCertify-api-reference": "Resources",
  "skillCertify-api-reference-description": "Enabling this setting allows candidates to view the resources during the assessment.",
  "skillCertify-api-reference-view": "View Resources",
  "skillCertify-add-track": "Add Track",
  "skillCertify-add-track-success": "The track is added.",
  "skillCertify-set-tip": "Select a level.",
  "skillCertify-recommend-time": "Recommended Time",
  "skillCertify-recommend-time-tip": "Recommended time to solve the track.",
  "skillCertify-remove-track": "Remove Track",
  "skillCertify-track-remove-title": "Are you sure you want to remove this track?",
  "common-remove": "Remove",
  "skillCertify-remove-track-success": "The track is successfully removed.",
  "skillCertify-reset-track": "Reset Track",
  "skillCertify-category": "Category",
  "advance-track-name-placeholder": "Search by track name",
  "advance-track-count": "Track | Tracks",
  "advance-track": "Track | Tracks",
  "skillCertify-view-description": "View Description",
  "advance-more-track": "Learn more about this track.",
  "skillCertify-view-guide": "View Guide",
  "advance-guide": "Guide",
  "advance-level": "Level",
  "advance-level-general": "General",
  "advance-level-entry": "Entry",
  "advance-level-beginner": "Beginner",
  "advance-level-intermediate": "Intermediate",
  "advance-level-professional": "Professional",
  "skillCertify-view-questions": "View Questions",
  "skillCertify-select": "Select",
  "skillCertify-select-info": "One of the various question sets at the level will be randomly selected.",
  "skillCertify-basic-info": "Basic Information",
  "skillCertify-assessment-name": "Assessment Name",
  "skillCertify-assessment-name-placeholder": "Enter the assessment name.",
  "skillCertify-assessment-internal": "Org Competency Assessment",
  "skillCertify-assessment-external": "External Talent Assessment",
  "skillCertify-assessment-internal-description": "Org competency assessment can help you diagnose your organization to understand employee competencies or manage human resources.",
  "skillCertify-assessment-external-description": "External talent assessment can be used to assess people outside of your organization, such as for hiring talent and selecting partners.",
  "skillCertify-period-info": "Candidates can only take this assessment within the period you set.",
  "common-open-date": "Open Date",
  "common-at": "at",
  "common-close-date": "Close Date",
  "skillCertify-period-error-invalid-both": "The close date & time can't be earlier than the open date & time.",
  "skillCertify-time-zone": "Time Zone",
  "skillCertify-time-zone-placeholder": "Search by time zone",
  "common-optional": "Optional | - Optional",
  "skillCertify-candidates-find-tip": "Candidates can check the description of this assessment.",
  "skillCertify-assessment-description-placeholder": "Enter a description of your assessment.",
  "skillCertify-assessment-duration-tip": "The duration is automatically set based on the tracks, you can adjust it as needed.",
  "skillCertify-assessment-duration-time-limit": "Time Limit",
  "common-duration-unlimited": "Unlimited",
  "skillCertify-assessment-duration-error": "You must set the duration.",
  "skillCertify-assessment-duration-change": "The duration has been adjusted based on your previous settings.",
  "common-previous": "Previous",
  "skillCertify-proctoring-description": "We recommend using the proctoring features to ensure fairness and prevent cheating.",
  "skillCertify-no-proctoring": "Don't use",
  "skillCertify-basic-proctoring": "Basic",
  "skillCertify-basic-proctoring-sub": "Web Browser",
  "skillCertify-advanced-proctoring": "Advanced",
  "skillCertify-advanced-proctoring-sub": "Proctive Program",
  "skillCertify-proctoring-screen-exit-detection": "Screen Exit Detection",
  "skillCertify-proctoring-screen-exit-detection-description": "This feature detects when candidates switch away from the assessment screen during the assessment.",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection": "Keyboard Shortcuts Restriction and Detection",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection-description-1": "This feature restricts unauthorized keyboard shortcuts and detects any attempt by candidates to use them during the assessment.",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection-description-2": "Unauthorized keyboard shortcuts include:",
  "skillCertify-proctoring-keyboard-shortcuts-restriction-and-detection-description-3": "those related to saving webpages, capturing screenshots, viewing source, and opening developer tools",
  "skillCertify-proctoring-multiple-monitor-restriction-and-detection": "Multiple Monitor Restriction and Detection",
  "skillCertify-proctoring-multiple-monitor-restriction-and-detection-description": "This feature restricts the use of multiple monitors and detects any attempt by candidates to use them during the assessment.",
  "skillCertify-proctoring-copy-cut-paste-detection": "Copy/Cut/Paste Detection",
  "skillCertify-proctoring-copy-cut-paste-detection-description": "This feature detects when candidates copy, cut, or paste code or text during the assessment.",
  "skillCertify-proctoring-partial-screen--recording": "Partial Screen Recording (When Cheating Is Detected)",
  "skillCertify-proctoring-partial-screen--recording-description-1": "This feature records the screen at the moment cheating occurs during the assessment.",
  "skillCertify-proctoring-partial-screen--recording-description-2": "When cheating is detected, multiple screenshots are captured, and a separate video is generated for each cheating incident based on these screenshots.",
  "skillCertify-proctoring-partial-screen--recording-description-3": "The recordings are securely stored and permanently deleted after 30 days.",
  "skillCertify-proctoring-partial-screen--recording-description-4": "Recordings become available after the assessment is graded by the administrator.",
  "skillCertify-proctoring-full-screen-recording": "Full Screen Recording (Entire Assessment)",
  "skillCertify-proctoring-full-screen-recording-description-1": "The screen is recorded from the start to the end of the assessment.",
  "skillCertify-proctoring-full-screen-recording-description-2": "The time when cheating is detected is recorded, enabling administrators to identify and review the corresponding segments in the recording.",
  "skillCertify-proctoring-face-voice-recording": "Face/Voice Recording",
  "skillCertify-proctoring-face-voice-recording-description-1": "Candidates must set up their camera and microphone before the assessment begins.",
  "skillCertify-proctoring-face-voice-recording-description-2": "This feature records the candidates' face and voice during the assessment.",
  "skillCertify-assessment-create-success": "The assessment has been created.",
  "skillCertify-assessment-create-fail": "We couldn't create the assessment. \nPlease try again.",
  "skillCertify-assessment-info": "Assessment Information",
  "skillCertify-candidates-list": "Candidates",
  "common-delete": "Delete",
  "skillCertify-assessment-delete-title": "Are you sure you want to delete this assessment?",
  "skillCertify-assessment-delete-info-1": "All of the candidates' assessment results will be deleted.",
  "skillCertify-assessment-delete-info-2": "Type 'Delete' and the [Delete] button will become active.",
  "skillCertify-assessment-delete-success": "The assessment is successfully deleted.",
  "skillCertify-assessment-delete-fail": "We couldn't delete the assessment.\nPlease try again.",
  "common-modify": "Modify",
  "skillCertify-modify-limit-title": "This assessment can't be modified",
  "skillCertify-modify-limit-description": "You can't edit this assessment because a candidate has started this assessment.",
  "common-update": "Update",
  "skillCertify-modify-success": "The assessment has been updated.",
  "skillCertify-modify-fail": "We couldn't update the assessment.\nPlease try again.",
  "common-invite": "Invite",
  "skillCertify-invite-candidates": "Invite Candidates",
  "skillCertify-invite-candidates-description": "Emails to invite can be added with a comma or enter key.\nOnce a candidate starts an assessment, you can't edit the assessment.",
  "skillCertify-invite-candidates-email-invalid": "'{email}' email is not valid.",
  "skillCertify-invite-candidates-success": "Assessment invitations have been sent to {count} of candidates.",
  "skillCertify-invite-candidates-fail": "We couldn't invite {count} candidate.\nPlease try again. | We couldn't invite {count} candidates.\nPlease try again.",
  "skillCertify-invite-candidates-duplicate-count": "There are already {count} invited candidate\nWould you like to invite after removing duplicates?|There are already {count} invited candidates \nWould you like to invite after removing duplicates?",
  "skillCertify-invite-candidates-duplicate-description": "After removing duplicates, only new candidates will be invited.",
  "skillCertify-invite-candidates-duplicate-warning": "There are already invited candidates.",
  "learning-start-assessment": "Start Assessment",
  "skillCertify-search-user-placeholder-new": "Search by full name or email",
  "skillCertify-candidate-report": "Report",
  "skillCertify-score-rank": "Score Rank",
  "skillCertify-skill-acquisition-rate-rank": "Skill Acquisition Rate Rank",
  "skillCertify-set-average-skill-acquisition-rate-info": "Average skill acquisition rate of all tracks.",
  "skillCertify-candidate-tracks-result-button": "View Tracks Result Data",
  "skillCertify-assessment-score-rank": "Assessment Score Rank",
  "skillCertify-assessment-score": "Assessment Score",
  "skillCertify-assessment-time-taken": "Assessment Time Taken",
  "skillCertify-assessment-skill-acquisition-rate-rank": "Assessment Skill Acquisition Rate Rank",
  "skillCertify-assessment-skill-acquisition-rate": "Assessment Skill Acquisition Rate",
  "profile-full-name": "Full Name",
  "common-link-copy": "The link is copied to the clipboard.",
  "skillCertify-candidate-count": "Candidate | Candidates",
  "skillCertify-candidate-info": "Candidate Information",
  "skillCertify-candidate-last-record": "Last Record",
  "skillCertify-candidate-invited-date": "Invited on",
  "skillCertify-candidate-ready-date": "Ready on",
  "skillCertify-candidate-started-date": "Started on",
  "skillCertify-candidate-completed-date": "Completed on",
  "common-time-taken": "Time Taken",
  "common-view": "View",
  "skillCertify-rank": "Rank",
  "skillCertify-candidate-resend-email": "Resend Email",
  "skillCertify-candidate-resend-email-description": "Do you want to resend the assessment invitation email to '{email}'?",
  "common-resend": "Resend",
  "skillCertify-candidate-resend-email-success": "We have resent the assessment invitation email to '{email}'.",
  "skillCertify-candidate-resend-email-fail": "We couldn't resend the assessment invitation email to '{email}'.\nPlease try again.",
  "skillCertify-set-average-score-info": "Average score of all tracks.",
  "skillCertify-action-timeline": "Timeline",
  "skillCertify-action-record-count": "Record | Records",
  "skillCertify-candidate-assessment-result": "Assessment Result",
  "skillCertify-score-grading": "Grading",
  "skillCertify-score-none-description": "Manual grading by the admin may take some time.",
  "skillCertify-candidate-report-button": "View Report",
  "common-read-more": "Read More",
  "skillCertify-candidate-none-data": "There are no candidates.",
  "skillCertify-candidate-select": "{count} Candidate selected | {count} Candidates selected",
  "skillCertify-delete-candidates": "Delete Candidates",
  "skillCertify-candidate-delete-1": "Are you sure you want to delete",
  "skillCertify-candidate-delete-2": "candidate? | candidates?",
  "skillCertify-candidate-delete-description": "The assessment result of the candidate will also be deleted. | The assessment results of the candidates will also be deleted.",
  "skillCertify-candidate-delete-success": "{count} candidate is successfully deleted. | {count} candidates are successfully deleted.",
  "skillCertify-candidate-delete-fail": "We couldn't delete {count} candidates.\nPlease try again.",
  "learning-view-guidelines": "View Guidelines",
  "learning-continue-assessment": "Continue Assessment",
  "skillCertify-account-miss-match": "You can't access because your account information doesn't match",
  "skillCertify-account-miss-match-description": "The currently logged in account doesn't match the account that received the invitation email.\nPlease log out and log in again, and if the problem persists, please contact your administrator.",
  "skillCertify-limit-permission-title": "You don't have permission to take this assessment",
  "skillCertify-limit-permission-description": "Contact your administrator for permission.",
  "skillCertify-assessment-duration-guide": "Check the duration before starting this assessment",
  "skillCertify-assessment-duration-description-1": "The duration is set according to the assessment close date.",
  "skillCertify-assessment-duration-description-2": "Duration to be set : {hour} h {minute} min",
  "skillCertify-assessment-guidelines": "Assessment Guidelines",
  "learning-assessment-guide-line-description-1": "Please join the {target} in {element}.",
  "learning-assessment-guild-line-element-1": "Google Chrome",
  "learning-assessment-guide-line-description-2": "Copying or taking screenshots of the questions is prohibited.",
  "learning-assessment-guide-line-description-3": "Posting information related to the exam questions or your answers on the internet or sharing them with others is prohibited.",
  "learning-assessment-guide-line-description-4": "We are not responsible for any technical issues that may arise during the {target} or any disadvantage that may result from failure to follow the instructions.",
  "learning-assessment-guide-line-description-5": "Please join the {target} in an area with a dependable internet connection. Avoid using public networks found at cafes or libraries.",
  "learning-assessment-guide-line-description-6": "Managing your {target} time is solely your responsibility, and failure to submit before the deadline results in penalties.",
  "learning-assessment-guide-line-description-7": "You can use the code-saving feature during a hands-on session.\nThe code-saving shortcuts are as follows.{element}",
  "learning-assessment-guild-line-element-2": "Windows users: Ctrl + S",
  "learning-assessment-guild-line-element-3": "MacBook and iMac users: Command + S",
  "learning-assessment-guide-line-description-8": "Usage of Chat GPT or similar programs may result in a zero score; this will be verified using an anti-cheating solution.",
  "learning-assessment-guide-line-description-9": "Any cheating that occurs during the {target} will be recorded by the system and may be reported to your administrator.",
  "learning-assessment-guide-line-description-10": "If the anti-cheating solution is not used, or interrupted midway, the results may be invalidated.",
  "learning-assessment-guide-line-description-for-mac-1": "To use the anti-cheating solution, MacBook and iMac users must grant access to screen recording.",
  "learning-assessment-guide-line-description-for-mac-2": "The setup path is as follows.",
  "learning-assessment-guide-line-description-for-mac-3": "Apple Menu → System Settings → Security & Privacy → Screen Recording → Unlock → Check Google Chrome → Restart Browser",
  "learning-assessment-guide-line-description-for-mac-4": "Apple Menu → System Settings → Security & Privacy → Screen Recording → Unlock → Check Proctive → Restart Proctive",
  "learning-assessment-guide-line-description-11": "Any disadvantage resulting from failure to follow the instructions of the anti-cheating solution is the sole responsibility of the participant.",
  "common-question": "Question | Questions",
  "skillCertify-assessment-outline": "Assessment Outline",
  "skillCertify-assessment": "Assessment | Assessments",
  "skillCertify-api-reference-info": "You can view the resources.",
  "common-description-button": "Open Description in Popup",
  "learning-finish": "Finish Assessment",
  "skillCertify-assessment-finish-question-title": "Do you want to finish this assessment?",
  "skillCertify-assessment-finish-question-description-success-submitted": "All answers have been submitted.",
  "skillCertify-assessment-finish-question-description-not-submitted": "Some answers haven't been submitted yet, please submit them.",
  "skillCertify-assessment-finish-question-description-common": "If you finish this assessment now, you can no longer view or modify this assessment.",
  "skillCertify-assessment-finish-question-description-check": "Please check again.",
  "skillCertify-assessment-finish-question-button": "Finish",
  "skillCertify-caution": "Caution",
  "skillCertify-caution-tab-switch": "Behaviors out of the screen have been identified.\nThis is being reported to your administrator, so don't leave the screen until you're done.",
  "common-continue": "Continue",
  "skillCertify-caution-tab-toast": "This is being reported to your administrator, so don't leave the screen until you're done.",
  "skillCertify-caution-short-cut-1": "Behavior using an unauthorized keyboard shortcut has been identified.\nThis is being reported to your administrator, so please don't use unauthorized keyboard shortcuts until you're done.",
  "skillCertify-caution-short-cut-2": "Keyboard shortcuts related to the actions below are not authorized.",
  "skillCertify-caution-short-cut-key-word-1": "Saving webpages",
  "skillCertify-caution-short-cut-key-word-2": "Capturing screenshots",
  "skillCertify-caution-short-cut-key-word-3": "Viewing source",
  "skillCertify-caution-short-cut-key-word-4": "Opening developer tools",
  "skillCertify-caution-short-cut-toast": "This is being reported to your administrator, so please don't use unauthorized keyboard shortcuts until you're done.",
  "skillCertify-caution-multiple-monitor": "Multi-monitor behavior has been identified.\nThis is being reported to your administrator, so please don't use multiple monitors until you're done.",
  "skillCertify-proctoring-face-voice-recording-no-detect-title": "Camera/Microphone can't be detected",
  "skillCertify-proctoring-face-voice-recording-no-detect-description": "Proctoring has been interrupted, and the process can't continue.\nPlease return to the start screen, reconfigure your camera/microphone, and try again.",
  "skillCertify-proctoring-face-voice-recording-no-detect-button": "Back to start screen",
  "hands-on-environment-setup-loading": "Setting up the hands-on environment.",
  "hands-on-environment-setup-loading-title": "Please wait a little longer.",
  "hands-on-environment-setup-completed": "Your hands-on environment is ready.",
  "hands-on-environment-setup-completed-info": "Click on the button below to continue your hands-on practice.",
  "hands-on-environment-setup-completed-button": "Continue Your Hands-on Practice",
  "hands-on-environment-setup-failed": "The hands-on environment setup failed.",
  "hands-on-environment-setup-failed-info": "Click on the button below to try setting it up again.",
  "hands-on-environment-setup-failed-button": "Retry setting up the hands-on environment",
  "hands-on-environment-setup-description": "The hands-on environment setup may take {time}.",
  "hands-on-environment-setup-description-time": "about {time} minutes",
  "embed-provisioning-phase-queued": "Waiting for available capacity…",
  "embed-provisioning-phase-launching": "Starting your environment…",
  "embed-provisioning-expired-info": "This is taking longer than expected. Please try setting it up again.",
  "embed-provisioning-still-preparing": "Your environment is still preparing. You can keep waiting or retry.",
  "learning-run-code-and-save": "Run Code and Save",
  "learning-rerun-and-save": "Rerun and Save",
  "learning-saved": "Saved.",
  "learning-save-failed": "Failed to save.",
  "skillCertify-end-time-info-title": "The assessment ends in {minutes} minutes\nPlease check again whether you have submitted your answers",
  "skillCertify-end-time-info-description": "If there are answers you haven't submitted yet, please submit them.",
  "skillCertify-assessment-finish-title": "Assessment finished",
  "skillCertify-assessment-finish-description": "The assessment time is over.\nThank you for taking the assessment.",
  "learning-fail-message": "We couldn't submit your answer because of a temporary error.",
  "learning-fail-message-retry": "Please try again.",
  "skillCertify-assessment-completed-title": "Your submitted answers have been sent to the administrator",
  "skillCertify-assessment-completed-description": "Complete your profile to highlight your experience and skills.",
  "skillCertify-assessment-completed-go-profile": "Go to Profile",
  "skillCertify-load-template": "Load Template",
  "skillCertify-template": "Template",
  "skillCertify-template-none-save-data": "There are no saved templates yet.",
  "common-apply": "Apply",
  "skillCertify-template-load-title": "Do you want to load this template?",
  "skillCertify-template-load-info": "All current tracks will be removed and replaced with tracks from the selected template.",
  "skillCertify-template-load-success": "The template has been applied.",
  "skillCertify-save-template": "Save as Template",
  "skillCertify-template-save-title": "Do you want to save the tracks as a template?",
  "skillCertify-template-save-info-1": "Saved templates can be used when {element}",
  "skillCertify-template-save-info-2": "creating or modifying assessments.",
  "skillCertify-template-name-placeholder": "Enter the template name.",
  "skillCertify-error-template-name": "The template name must be between 1 and 30 characters.",
  "skillCertify-template-save-success": "The template has been saved.",
  "skillCertify-template-save-fail": "We couldn't save the template.\nPlease try again.",
  "skillCertify-template-management": "Template Management",
  "skillCertify-search-template-name-placeholder": "Search by template name",
  "skillCertify-template-edit-title": "Are you sure you want to edit the template name?",
  "skillCertify-template-edit-success": "The template name has been edited.",
  "skillCertify-template-edit-fail": "We couldn't edit the template name.\nPlease try again.",
  "skillCertify-template-delete-title": "Are you sure you want to delete this template?",
  "skillCertify-template-delete-success": "The template has been successfully deleted.",
  "skillCertify-template-delete-fail": "We couldn't delete the template.\nPlease try again.",
  "skillCertify-caution-multiple-monitor-title": "Check your monitor setup",
  "skillCertify-caution-multiple-monitor-description": "Using multiple monitors may be considered cheating. \nIf multiple monitors are connected, please disconnect them.",
  "skillCertify-caution-multiple-monitor-enable": "No multiple monitors connected",
  "skillCertify-caution-multiple-monitor-disable-1": "Multiple monitors connected",
  "skillCertify-caution-multiple-monitor-disable-2": "(Disconnection Required)",
  "skillCertify-caution-recording-title": "Please agree to recording",
  "skillCertify-caution-recording-description-basic": "To prevent cheating, your screen will be recorded.\nThe recordings are securely stored and permanently deleted after 30 days.",
  "skillCertify-caution-recording-agree-basic": "I agree to recording of the screen.",
  "skillCertify-caution-recording-description": "To prevent cheating, your screen and face/voice will be recorded.\nThe recordings are securely stored and permanently deleted after 30 days.",
  "skillCertify-caution-recording-agree": "I agree to recording of the screen and face/voice.",
  "skillCertify-install-proctoring-program-title": "Please install Proctive",
  "skillCertify-install-proctoring-program-description": "To proceed, the proctoring program needs to be installed.\nPlease install it using the link below.",
  "skillCertify-install-proctoring-program-description-bold": "After installation, close this window and try again.",
  "skillCertify-update-proctoring-program-title": "Please update Proctive",
  "skillCertify-update-proctoring-program-description": "To proceed, the proctoring program needs to be updated.\nPlease update it using the link below.",
  "skillCertify-basic-proctoring-recording-fail-title": "Recording is not functioning properly",
  "skillCertify-basic-proctoring-recording-fail-description": "The assessment can't be continued because recording is not functioning properly.\nPlease try again, and if the problem persists, please contact {email}",
  "skillCertify-proctoring-recording-fail-title": "Recording is not functioning properly\nPlease check the settings below and restart Proctive",
  "skillCertify-proctoring-recording-fail-description": "Kindly check the permissions and connection status of your camera and microphone.",
  "skillCertify-proctoring-face-voice-recording-set-up-title": "Please set up your camera and microphone",
  "skillCertify-proctoring-face-voice-recording-set-up-camera": "Camera",
  "skillCertify-proctoring-face-voice-recording-set-up-microphone": "Microphone",
  "skillCertify-proctoring-face-voice-recording-set-up-retry": "Retry",
  "skillCertify-proctoring-face-voice-recording-set-up-retry-description": "Recheck your camera and microphone connection.",
  "skillCertify-proctoring-face-voice-recording-set-up-fail-title": "Camera/Microphone connection failed",
  "skillCertify-proctoring-face-voice-recording-set-up-fail-description": "Please check the permissions and connection status of your camera and microphone.",
  "skillCertify-proctoring-screen-record-title": "Please share your entire screen",
  "skillCertify-proctoring-full-screen-error": "To proceed with the assessment, you must share your **entire screen**.",
  "skillCertify-proctoring-entire-screen-recording-no-access-title": "Screen recording can't be started\nPlease check the following settings",
  "skillCertify-proctoring-entire-screen-recording-no-access-description-1": "Make sure screen recording permission is enabled.",
  "skillCertify-proctoring-entire-screen-recording-no-access-description-2": "Make sure no software that blocks screenshots or prevents screen recording is running.",
  "skillCertify-proctoring-entire-screen-recording-no-access-description-3": "If the problem persists, please contact {email}",
  "skillCertify-aws-label": "AWS",
  "skillCertify-web-ide-label": "Web IDE",
  "skillCertify-prompt-label": "Prompt",
  "skillCertify-agent-prompt-label": "Agent Prompt",
  "skillCertify-command-multiple-choice-label": "Command & Multiple Choice",
  "skillCertify-command-label": "Command",
  "skillCertify-code-no-run-code-label": "Code (No Run Code)",
  "skillCertify-command-short-answer-label": "Command & Short Answer",
  "skillCertify-code-label": "Code",
  "skillCertify-multiple-files-code-label": "Multiple Files Code",
  "skillCertify-jupyter-notebook-label": "Jupyter Notebook",
  "skillCertify-coding-agent-label": "Coding Agent",
  "skillCertify-take-assessment-description": "An overview of all invited assessments and sample assessments.",
  "skillCertify-sample-information-title": "Please check the information before starting the sample assessment",
  "skillCertify-sample-information-new-description-1": "The sample assessment is an assessment to preview the proctoring features or question types in advance, and correct answers and results are not provided.",
  "skillCertify-sample-information-new-description-2": "Recordings and action logs generated by the proctoring features are not saved and are not reported to the administrator either.",
  "skillCertify-sample-information-new-description-3": "The Code Sample Assessment may be provided in a different programming language from the actual assessment.",
  "skillCertify-sample-information-new-description-4": "You can try the sample assessment before starting your invited assessment. (Unavailable after the assessment has ended)",
  "skillCertify-sample-unavailable-description": "The sample assessment is currently unavailable.\nYou can try it once you're invited to an upcoming or ongoing assessment.",
  "skillCertify-sample-token-limit-info": "This assessment has a limited token usage, so response generation stops once the limit is reached.",
  "skillCertify-sample-assessment-completed-title": "You have completed the sample assessment",
  "skillCertify-sample-assessment-completed-description": "Retake or try another sample assessment.",
  "skillCertify-sample-assessment-completed-try-sample-assessment": "Try Sample Assessment",
  "skillCertify-command-question-type": "Question Type",
  "skillCertify-command-basic-proctoring-label": "Basic Proctoring",
  "skillCertify-command-advanced-proctoring-label": "Advanced Proctoring",
  "skillCertify-proctoring-screen-record-description-3": "Generated videos will be permanently deleted after 30 days.",
  "common-retry": "Try again",
  "assessment-provision-failed": "We couldn't prepare your practice environment.\nPlease try again, or contact support if the problem continues.",
  "skillCertify-advanced-proctoring-restriction-info": "Advanced Proctoring is available on Pro and Enterprise plans.",
  "skillCertify-advanced-proctoring-restriction-info-2": "If you'd like to use Advanced Proctoring, please contact your account manager.",
  "skillCertify-report-language-tip": "The assessment report and candidate report will be generated in the selected language.",
  "skillCertify-report-language-info-1": "The Basic plan allows only one report language.",
  "skillCertify-report-language-info-2": "Additional report languages are available on Pro and Enterprise plans.",
  "skillCertify-creation-restriction-info-1-title": "You can't create an assessment because\nthere is no active subscription plan",
  "skillCertify-creation-restriction-info-2-title": "You can't create an assessment because\nyour subscription has ended",
  "credit-certify-creation-limit-description-1": "If you need more credits, you can purchase them in {linkDom}.",
  "credit-certify-creation-limit-description-2": "Credit Management",
  "credit-certify-creation-limit-button": "Go to Credit Management",
  "credit-certify-invitation-restriction-info-title": "You can't invite candidates because\nyour subscription has ended",
  "skillCertify-assessment-time-added": "{minutes} min added",
  "skillCertify-assessment-time-extension-history": "Time Extension History",
  "skillCertify-assessment-total-added-time": "Total Added Time",
  "skillCertify-assessment-time-added-toast": "The assessment time has been extended by {minutes} minutes.",
  "skillCertify-core-label": "Core",
  "skillCertify-e2e-label": "E2E",
  "skillCertify-aI-fluent-label": "AI Fluent",
  "skillCertify-plan-restriction-info": "For Pro / Enterprise Plans Only",
  "skillCertify-calculation-basis": "Calculation Basis",
  "skillCertify-credit": "Credit",
  "skillCertify-track-count": "{count} Track | {count} Tracks",
  "skillCertify-credit-count": "{count} Credit | {count} Credits",
  "skillCertify-credit-info": "When inviting 1 candidate,",
  "skillCertify-credit-info-1": "{count}",
  "skillCertify-credit-info-2": "credit will be used. | credits will be used.",
  "skillCertify-select-disabled-info-1": "AI Fluent track is unavailable because the Core or E2E track has been selected.",
  "skillCertify-select-disabled-info-1-1": "AI Fluent track can only be used on its own.",
  "skillCertify-select-disabled-info-2": "AI Fluent track is selected, so you can't select other tracks.",
  "skillCertify-select-disabled-info-2-1": "AI Fluent track can only be used on its own.",
  "skillCertify-tracks-settings-disabled-info-1": "You can't change the tracks after inviting candidates.",
  "skillCertify-tracks-settings-disabled-info-2": "The basic information and proctoring features can be modified in the next step, and you can change the tracks again by deleting all invited candidates.",
  "skillCertify-invite-candidates-candidate-count": "Invite {count} candidate | Invite {count} candidates",
  "skillCertify-invite-candidates-credit-count": "{count} credit will be used | {count} credits will be used",
  "skillCertify-invite-candidates-credit-count-per-candidate": "{count} credit will be used per candidate | {count} credits will be used per candidate ",
  "skillCertify-invite-candidates-estimated-remaining": "Estimated remaining after invitation",
  "skillCertify-invite-candidates-insufficient-credits": "Insufficient Credits",
  "skillCertify-calculation-basis-track-count": "Number of Tracks Set",
  "skillCertify-calculation-basis-credit-count": "Number of Credits to Deduct",
  "webcam-recording-active": "Webcam recording active",
  "SkillCertify-duplicate-session-warning-title": "The assessment has started on another screen",
  "SkillCertify-duplicate-session-warning-description": "You can no longer continue the assessment on this screen.",
  "skillCertify-tracks-setup-method": "Track Setup Method",
  "skillCertify-tracks-setup-manual": "Manual Setup",
  "skillCertify-tracks-select-manually": "Select tracks manually",
  "skillCertify-tracks-ai-recommendation": "AI Recommendation",
  "skillCertify-tracks-get-recommendation": "Get track recommendations",
  "skillCertify-tracks-setup-method-change-title": "Do you want to change the track setup method?",
  "skillCertify-tracks-setup-method-change-description": "The current track settings will be reset.",
  "skillCertify-tracks-recommendation-input-guide": "Please enter the information needed for track recommendations.",
  "skillCertify-tracks-recommendation-credit-info": "One AI recommendation credit will be used when you get a recommendation.",
  "skillCertify-tracks-recommendation-monthly-limit-basic": "5 per month",
  "skillCertify-tracks-recommendation-monthly-limit-pro": "20 per month",
  "skillCertify-tracks-recommendation-job-role": "Job Role",
  "skillCertify-tracks-recommendation-job-role-placeholder": "Please select a job role.",
  "skillCertify-tracks-recommendation-job-role-backend": "Backend Developer",
  "skillCertify-tracks-recommendation-job-role-frontend": "Frontend Developer",
  "skillCertify-tracks-recommendation-job-role-ai-ml": "AI/ML Engineer",
  "skillCertify-tracks-recommendation-work-experience-placeholder": "Please select your work experience.",
  "skillCertify-tracks-recommendation-work-experience-entry": "Entry-2 years",
  "skillCertify-tracks-recommendation-work-experience-mid": "3-5 years",
  "skillCertify-tracks-recommendation-work-experience-senior": "6+ years",
  "skillCertify-tracks-recommendation-keywords": "Job description or skill keywords",
  "skillCertify-tracks-recommendation-keywords-placeholder": "Please enter a job description or skill keywords.\ne.g., Python, Java, AWS",
  "skillCertify-tracks-recommendation-submit": "Get Recommendations",
  "skillCertify-tracks-recommendation-limit-reached": "You've used all your AI recommendations.\nYou can use this feature again at the next refresh.",
  "skillCertify-tracks-recommendation-fail": "We couldn't get recommendations due to a temporary error.\nPlease try again.",
  "skillCertify-tracks-recommendation-loading": "AI is finding suitable tracks.\nPlease wait for a moment.",
  "skillCertify-tracks-recommendation-no-result": "We couldn't find recommended tracks matching your criteria.\nPlease edit your information and try again.",
  "skillCertify-tracks-recommendation-edit-info": "Edit Information",
  "skillCertify-tracks-recommendation-entered-info": "Entered Information",
  "skillCertify-tracks-recommendation-reason": "Recommendation Reason",
  "skillCertify-tracks-recommendation-show-more": "Show More",
  "skillCertify-tracks-recommendation-show-less": "Show Less",
  "skillCertify-tracks-recommendation-reason-fail": "We couldn't load the recommendation reason.",
  "skillCertify-tracks-recommendation-result": "Recommended Tracks",
  "skillCertify-tracks-recommendation-result-guide": "Please select the tracks to set from the recommended tracks below.",
  "skillCertify-tracks-recommendation-matching-basis": "Matching Keywords",
  "skillCertify-tracks-recommendation-no-desired-track": "Can't find the track you want?",
  "skillCertify-tracks-recommendation-edit-info-title": "Do you want to edit your information?",
  "skillCertify-tracks-recommendation-edit-info-description": "The current recommended tracks will be reset.",
  "skillCertify-tracks-recommendation-apply-selected": "Apply Selected Tracks",
  "skillCertify-tracks-recommendation-apply-success": "The recommended tracks have been applied.",
  "skillCertify-current-question": "Current Question",
  "skillCertify-answer-status-not-submitted": "Not Submitted",
  "skillCertify-answer-status-submitted": "Submitted",
  "skillCertify-answer-status-resubmit-required": "Resubmission Required",
  "skillCertify-submit-answer-for-grading": "Please submit your answer for grading.",
  "skillCertify-away-with-out-title": "The answer to the current question has not been submitted yet\nDo you want to submit your answer?",
  "skillCertify-away-with-out-description-1": "We recommend submitting your answer before leaving.",
  "skillCertify-away-with-out-description-2": "You can resubmit your answer if you make any additional changes after submitting.",
  "skillCertify-away-with-out-leave": "Leave without submitting",
  "skillCertify-locale-change-with-out-submitting-description": "We recommend submitting your answer before changing the language.",
  "skillCertify-locale-change-with-out-submitting": "Change language without submitting",
  "skillCertify-submit-answer-require-run-code-and-save": "Please click Run Code and Save, before submitting your answer.",
  "skillCertify-question-provides-api-reference": "This question provides {resourcesLink}.",
  "skillCertify-device-block-title": "You can only take the assessment on a PC",
  "skillCertify-device-block-description": "Please try again after connecting from a PC.\nIf you need help, please contact us via Channel Talk.",
  "skillCertify-environment-check-start-button": "Start Environment Check",
  "skillCertify-environment-check-title": "Please check your test environment",
  "skillCertify-environment-check-description": "Before the assessment begins, you must check that your camera, microphone, and screen recording are working properly.\nThe assessment timer starts only after you complete the check and begin the assessment.",
  "skillCertify-environment-check-result-title": "Check Results",
  "skillCertify-environment-check-status-checking": "Checking...",
  "skillCertify-environment-check-status-ok": "Normal",
  "skillCertify-environment-check-status-failed": "Check Required",
  "skillCertify-environment-check-has-failed-item": "Some items were not confirmed as normal.",
  "skillCertify-environment-check-help-button": "View Solution",
  "skillCertify-environment-check-help-title": "Solution",
  "skillCertify-environment-check-help-camera-microphone": "Camera/Microphone",
  "skillCertify-environment-check-help-detail-guide": "See Help page for detailed solutions",
  "skillCertify-environment-check-contact-channel-talk": "If you need help, please contact us via Channel Talk.",
  "skillCertify-environment-check-screen-share-guide-title": "Please check screen sharing",
  "skillCertify-environment-check-screen-share-guide-description": "Before the assessment begins, you must check that screen sharing is working properly.\nPlease share your **entire screen** during the check.\nThe assessment timer starts only after you complete the check and begin the assessment.",
  "skillCertify-environment-check-screen-share-button": "Check Screen Sharing",
  "skillCertify-environment-check-screen-share-complete-title": "Screen sharing check complete",
  "skillCertify-environment-check-screen-share-complete-description": "To start the assessment, click on the button below.",
  "skillCertify-environment-check-full-screen-error": "To check screen sharing, you must share your **entire screen**.",
  "skillCertify-environment-check-cancelled-toast": "You must complete the check before you can start the assessment.",
  "skillCertify-environment-check-screen-share-permission-required": "Screen sharing permission is required\nPlease check the following settings",
  "skillMonitor-main-description": "Monitor the accurately measured proficiency data of your organization's members and external workforce, and effectively leverage it for decision-making in project assignments, training, recruitment, and more.",
  "skillMonitor-main-sample-title": "You can currently view sample data.",
  "skillMonitor-main-sample-description": "The real data will appear once the assessment is created.",
  "skillMonitor-main-sample-do-not-again": "Don't show again",
  "skillMonitor-main-limit-permission-title": "You don't have permission to access this page",
  "skillMonitor-main-limit-permission-description": "You can only view pages related to the organization you belong to.",
  "skillMonitor-assessments-overview": "Assessments Overview",
  "skillMonitor-candidates-overview": "Candidates Overview",
  "common-total": "Total",
  "skillMonitor-closed-assessment-count": "Closed Assessment | Closed Assessments",
  "skillMonitor-chart-last": "Last",
  "skillMonitor-chart-months": "12 Months",
  "skillMonitor-summary-none-closed-assessment": "There are no closed assessments yet.",
  "skillMonitor-chart-completed-candidates-count": "Number of candidate who completed | Number of candidates who completed",
  "skillMonitor-summary-none-closed-candidate": "There are no candidates who have completed yet.",
  "common-average": "Average",
  "skillMonitor-main-track-level": "Level Distributions",
  "skillMonitor-chart-none-track-level": "There are no level data yet.",
  "skillMonitor-chart-track-level": "Track Level Distribution of Candidates",
  "skillCertify-candidate": "Candidate | Candidates",
  "skillMonitor-main-assessment-list": "Assessments",
  "skillMonitor-main-assessment-list-more": "See All Assessments",
  "skillMonitor-completed-candidate": "Candidates who completed",
  "skillMonitor-main-candidate-list-more": "See All Candidates",
  "skillMonitor-main-assessment-list-banner": "You can check the assessments created by your organization.",
  "skillMonitor-candidate-list-banner": "You can check candidates who have completed the assessments.",
  "skillMonitor-action-date": "Action Occurred Date",
  "skillMonitor-action-screen-switch": "Screen Switch",
  "skillMonitor-action-shortcut": "Unauthorized Shortcut",
  "skillMonitor-action-multi-monitor": "Multiple Monitors Connected",
  "skillMonitor-action-copy": "Copy",
  "skillMonitor-action-cut": "Cut",
  "skillMonitor-action-paste": "Paste",
  "skillMonitor-action-type": "Action Type",
  "skillMonitor-filter-by": "Filter by",
  "skillMonitor-track-info": "Tracks Information",
  "skillMonitor-assessment-submission": "Submissions",
  "skillMonitor-assessment-partially-answer": "Partially Correct Answer",
  "skillMonitor-assessment-incorrect-answer": "Incorrect Answer",
  "skillMonitor-assessment-incorrect": "Incorrect",
  "skillMonitor-assessment-answerer": "{userName}'s Answer",
  "skillMonitor-assessment-answerer-none": "No answer has been submitted.",
  "skillMonitor-analysis-title": "Indicators about {userName}",
  "skillMonitor-analysis-metric-name": "Static Analysis Category",
  "common-result": "Result",
  "skillMonitor-analysis-severity": "Severity",
  "skillMonitor-analysis-metric-tooltip-DUPLICATIONS": "It indicates duplicated code.",
  "skillMonitor-analysis-metric-tooltip-CYCLOMATIC_COMPLEXITY": "A metric that measures the complexity of code by calculating the number of logical paths in the program. The more conditions or loops a program has, the higher its complexity.",
  "skillMonitor-analysis-metric-tooltip-BUGS": "It indicates potential bugs in the code.",
  "skillMonitor-analysis-metric-tooltip-CODING_STYLE": "Evaluates whether the code adheres to consistent style and standards.",
  "skillMonitor-analysis-code-smell": "Code Smell",
  "skillMonitor-analysis-code-smell-long-method": "When a method is too long and includes too many tasks within a single method.",
  "skillMonitor-analysis-code-smell-large-class": "When a class has an excessive number of fields and methods, taking on too many responsibilities.",
  "skillMonitor-analysis-code-smell-primitive-obsession": "When basic data types (e.g., int, string) are excessively used, resulting in an unclear domain model.",
  "skillMonitor-analysis-code-smell-long-parameter-list": "List: When a method has an excessive number of parameters, making it difficult to use and maintain.",
  "skillMonitor-analysis-code-smell-data-clumps": "When specific groups of data frequently appear together.",
  "skillMonitor-analysis-code-smell-alternative-classes-with-different-interfaces": "When similar classes performing similar functions use different interfaces.",
  "skillMonitor-analysis-code-smell-refused-bequest": "When a subclass does not use the methods or fields inherited from its superclass.",
  "skillMonitor-analysis-code-smell-switch-statements": "When switch statements or if-else blocks are used repeatedly or become excessively complex.",
  "skillMonitor-analysis-code-smell-temporary-field": "When a class field is used only in specific situations, hindering code readability and maintainability.",
  "skillMonitor-analysis-code-smell-divergent-change": "When a class undergoes frequent changes for different reasons.",
  "skillMonitor-analysis-code-smell-parallel-inheritance-hierarchies": "When one class hierarchy maintains a parallel structure with another class hierarchy and has strong dependencies.",
  "skillMonitor-analysis-code-smell-shotgun-surgery": "When a small change propagates across multiple classes in the project, requiring widespread modifications.",
  "skillMonitor-analysis-code-smell-comments": "When the code is not self-explanatory, requiring excessive comments or relying solely on comments to convey its intent.",
  "skillMonitor-analysis-code-smell-duplicate-code": "When identical code is duplicated across multiple locations.",
  "skillMonitor-analysis-code-smell-data-class": "A data-only class that contains only fields and getter/setter methods.",
  "skillMonitor-analysis-code-smell-dead-code": "When unused code remains in the project.",
  "skillMonitor-analysis-code-smell-lazy-class": "When a class has too few responsibilities, making its existence unjustified.",
  "skillMonitor-analysis-code-smell-speculative-generality": "Generalized code created with potential future use in mind but currently unnecessary.",
  "skillMonitor-analysis-code-smell-feature-envy": "A method that pays more attention to the data of another class than to its own class.",
  "skillMonitor-analysis-code-smell-inappropriate-intimacy": "When two classes are overly dependent on each other, deeply accessing each other's internals.",
  "skillMonitor-analysis-code-smell-incomplete-library-class": "When a library class being used fails to provide the necessary functionality, causing inconvenience.",
  "skillMonitor-analysis-code-smell-message-chains": "When method calls are consecutively linked, forming an excessively long chain.",
  "skillMonitor-assessment-candidates-result": "Candidates Result",
  "skillMonitor-assessment-report-guide": "Report Interpretation Guide",
  "skillMonitor-assessment-summary-title": "Assessment Summary",
  "skillMonitor-track-summary-title-change": "Track Summary",
  "skillMonitor-skill-summary-title": "Skills Summary",
  "skillMonitor-assessment-summary-candidates-rate": "Completion Rate",
  "skillMonitor-assessment-summary-skill-rate": "Skill Acquisition Rate",
  "skillMonitor-assessment-summary-result": "Assessment Result Summary",
  "skillMonitor-assessment-summary-track-table-title": "Description by Tracks",
  "skillMonitor-track-summary-result": "Track Result Summary",
  "skillMonitor-track-summary-score-info": "Track Score Information",
  "skillMonitor-track-summary-min": "Minimum",
  "skillMonitor-track-summary-mid": "Median",
  "skillMonitor-track-summary-max": "Maximum",
  "skillMonitor-track-summary-highest": "Highest",
  "skillMonitor-track-summary-lowest": "Lowest",
  "skillMonitor-track-summary-score-highest-info": "This is the track with the highest average score.",
  "skillMonitor-track-summary-score-lowest-info": "This is the track with the lowest average score.",
  "skillMonitor-track-summary-high": "High",
  "skillMonitor-track-summary-low": "Low",
  "skillMonitor-track-summary-table-standard-deviation": "Standard Deviation",
  "skillMonitor-track-summary-table-average-time-taken": "Average Time Taken",
  "skillMonitor-assessment-candidates-chart-track-score": "Track Score Distribution of Assessment Candidates",
  "skillMonitor-all-candidates-based-info-top": "Top",
  "skillMonitor-all-candidates-based-info-bottom": "Bottom",
  "skillMonitor-assessment-candidates-chart-track-score-range": "Score Range",
  "skillMonitor-assessment-candidates-chart-track-time-taken-range": "Time Taken (min) Range",
  "skillMonitor-assessment-candidates-chart-track-skill-rate-range": "Skill Acquisition Rate (%) Range",
  "skillMonitor-assessment-candidates-chart-percentage": "Percentage of Assessment Candidates",
  "skillMonitor-assessment-candidates-chart-button": "View Candidates by Range",
  "skillMonitor-assessment-candidates-chart-track-time-taken": "Track Time Taken Distribution of Assessment Candidates",
  "skillMonitor-track-summary-skill-acquisition-rate-and-time-taken-info": "Track Skill Acquisition Rate and Time Taken Information",
  "skillMonitor-track-summary-skill-rate-highest-info": "This is the track with the highest average skill acquisition rate.",
  "skillMonitor-track-summary-skill-rate-lowest-info": "This is the track with the lowest average skill acquisition rate.",
  "skillMonitor-assessment-candidates-chart-track-skill-rate": "Track Skill Acquisition Rate Distribution of Assessment Candidates",
  "skillMonitor-track-summary-skill-info": "Track Skill Information",
  "skillMonitor-track-summary-skill-acquired": "Acquired",
  "skillMonitor-track-summary-skill-needs-Improvement": "Needs Improvement",
  "skillMonitor-track-summary-skill-not-acquired": "Not Acquired",
  "skillMonitor-assessment-candidates-chart-track-skill-level": "Track Skill Level Distribution of Assessment Candidates",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend": "Skill Level",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend-acquired": "Competency acquired",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend-needs-Improvement": "Understands the concept, but needs improvement in competency for applying and utilizing it in practice.",
  "skillMonitor-assessment-candidates-chart-track-skill-level-legend-not-acquired": "Competency not acquired",
  "skillMonitor-assessment-summary-result-none-data": "There is no result summary yet.\nThe result summary will be generated after the assessment is closed.",
  "skillMonitor-candidate-report-unsubmitted-1": "The candidate did not submit responses to any of the assessment questions.\nAs a result, there is insufficient basis to objectively determine whether each competency has been acquired or to evaluate its detailed proficiency level, making an overall competency diagnosis impossible.",
  "skillMonitor-candidate-report-unsubmitted-2": "The candidate submitted no responses in this assessment, making it impossible to evaluate the associated competency.",
  "skillMonitor-sort-by": "Sort by",
  "skillMonitor-candidates-summary-title": "Candidates Summary",
  "skillMonitor-candidates-summary-result": "Candidates Result Summary",
  "skillMonitor-score-based-info": "Based on Score",
  "skillMonitor-skill-acquisition-rate-based-info": "Based on Skill Acquisition Rate",
  "skillMonitor-candidates-Integrity-concerns-info": "Candidates with Integrity Concerns",
  "skillMonitor-candidates-Integrity-reason": "Reason",
  "skillMonitor-candidate-action-analysis-result": "Action Analysis Result",
  "skillMonitor-candidate-report": "Candidate Report",
  "skillMonitor-assessment-summary-score-info": "Assessment Score Information",
  "skillMonitor-summary-table-assessment-average-score": "vs. Avg. Score (Assessment Candidates)",
  "skillMonitor-summary-table-assessment-average-none": "Since there is only one total candidate,\ncomparative average data is not provided.",
  "skillMonitor-assessment-candidates-chart-assessment-score": "Assessment Score Distribution of Assessment Candidates",
  "skillMonitor-assessment-candidates-chart-assessment-time-taken": "Assessment Time Taken Distribution of Assessment Candidates",
  "skillMonitor-assessment-summary-skill-acquisition-rate-and-time-taken-info": "Assessment Skill Acquisition Rate and Time Taken Information",
  "skillMonitor-summary-table-assessment-average-skill-rate": "vs. Avg. Skill Acquisition Rate\n(Assessment Candidates)",
  "skillMonitor-assessment-candidates-chart-assessment-skill-rate": "Assessment Skill Acquisition Rate Distribution of Assessment Candidates",
  "skillMonitor-assessment-submission-button": "View Submissions",
  "skillMonitor-track-summary-score-highest-info-2": "This is the track with the highest score.",
  "skillMonitor-track-summary-score-lowest-info-2": "This is the track with the lowest score.",
  "skillMonitor-track-summary-skill-rate-highest-info-2": "This is the track with the highest skill acquisition rate.",
  "skillMonitor-track-summary-skill-rate-lowest-info-2": "This is the track with the lowest skill acquisition rate.",
  "skillMonitor-candidate-strength-button": "View Strength",
  "skillMonitor-candidate-areas-for-improvement-button": "View Areas for Improvement",
  "skillMonitor-candidate-strength-areas-for-improvement-button": "View Strength and Areas for Improvement",
  "skillMonitor-candidate-strength": "Strength",
  "skillMonitor-candidate-areas-for-improvement": "Areas for Improvement",
  "skillMonitor-candidate-sw-quality-analysis-result": "SW Quality Analysis Result",
  "skillMonitor-candidate-sw-quality-analysis-result-info": "SW quality analysis results are provided only for analyzable questions.",
  "skillMonitor-candidate-sw-quality-analysis-result-count": "{total} out of {question} Questions",
  "skillMonitor-candidate-sw-quality-analysis-summary-result": "SW Quality Analysis Result Summary",
  "skillMonitor-candidate-sw-quality-analysis-recommendations-for-improvement": "Recommendations for improvement",
  "skillMonitor-static-analysis-metrics-count": "{count} Metric | {count} Metrics",
  "skillMonitor-analysis-primary-file": "Analyzed Files",
  "skillMonitor-analysis-pass": "Pass",
  "skillMonitor-analysis-warning": "Warning",
  "skillMonitor-analysis-fail": "Fail",
  "skillMonitor-analysis-not-applicable": "Not Computed",
  "skillMonitor-candidate-action-analysis-info": "Action Analysis Information",
  "skillMonitor-candidates-Integrity-grade": "Integrity Grade",
  "skillMonitor-candidates-grade": "Grade",
  "skillMonitor-candidates-Integrity-grade-1": "Clean",
  "skillMonitor-candidates-Integrity-grade-1-description": "During the assessment, no suspicious actions or cheating attempts were detected, and the candidate fully complied with all rules.",
  "skillMonitor-candidates-Integrity-grade-2": "Minor Concern",
  "skillMonitor-candidates-Integrity-grade-2-description": "During the assessment, some suspicious actions were detected, but no clear evidence of cheating was found, and the candidate generally complied with the rules.",
  "skillMonitor-candidates-Integrity-grade-3": "Needs Review",
  "skillMonitor-candidates-Integrity-grade-3-description": "During the assessment, suspicious actions that may indicate cheating were detected, and additional manual review is required.",
  "skillMonitor-candidates-Integrity-grade-4": "Attempted Violation",
  "skillMonitor-candidates-Integrity-grade-4-description": "During the assessment, clear evidence of attempted cheating was detected, but the attempt was unsuccessful.",
  "skillMonitor-candidates-Integrity-grade-5": "Violation",
  "skillMonitor-candidates-Integrity-grade-5-description": "During the assessment, clear cheating was detected, significantly compromising the reliability of the test results.",
  "skillMonitor-report-candidate-action-analysis-clean-default-reason": "No misconduct was detected during this assessment.",
  "skillMonitor-candidate-action": "Candidate Action Log",
  "skillMonitor-candidate-action-count": "Action | Actions",
  "skillMonitor-candidate-video-delete": "This video has been deleted.",
  "skillMonitor-candidate-video-no-save": "This video wasn't saved.",
  "skillMonitor-candidate-recommended-for-review-label": "Recommended for Review",
  "skillMonitor-candidate-video-recording-duration-information": "Recording Duration Information",
  "skillMonitor-candidate-video-start": "Start",
  "skillMonitor-candidate-video-end": "End",
  "skillMonitor-candidate-video-current": "Current",
  "skillMonitor-candidate-video-no-face-voice-recording": "No Face/Voice Recording",
  "skillMonitor-candidate-video-no-screen-recording": "No Screen Recording",
  "skillMonitor-candidate-video-no-description": "Recording gaps are periods in which no recording data exists due to candidate disengagement, system interruptions or other technical issues.",
  "skillMonitor-candidate-video-playback-speed": "Playback Speed",
  "skillMonitor-candidate-video-view-full-screen": "View Full Screen",
  "skillMonitor-candidate-video-screen-recording": "Screen Recording",
  "skillMonitor-assessment-report-get-by-email": "Get Assessment Report by Email",
  "skillMonitor-candidate-report-get-by-email": "Get Candidate Report by Email",
  "skillMonitor-all-candidate-report-get-by-email": "Get All Candidate Reports by Email",
  "skillMonitor-assessment-send-report-title": "Enter the email address to receive the report",
  "skillMonitor-assessment-send-report-description": "The report will be sent as a {pdf} to the email you entered and may take some time to arrive.",
  "skillMonitor-assessment-send-report-description-pdf": "PDF",
  "skillMonitor-assessment-send-report-description-zip": "ZIP",
  "skillMonitor-assessment-send-report-button": "Send Report",
  "skillMonitor-assessment-send-report-success": "Your report request has been completed.",
  "skillMonitor-assessment-send-report-fail": "We couldn't complete the report sending request.\nPlease try again.",
  "home-event-title": "Codepresso Events",
  "home-event-count": "Event | Events",
  "home-event-type-Webinar": "Webinar",
  "home-event-type-Conference": "Conference",
  "home-event-type-Seminar": "Seminar",
  "home-event-type-Workshop": "Workshop",
  "home-event-type-NetworkingEvent": "Networking Event",
  "home-event-type-Exhibition": "Exhibition",
  "home-event-type-LaunchEvent": "Launch Event",
  "home-event-type-Learnathon": "Learnathon",
  "home-event-engage-Online": "ONLINE",
  "home-event-engage-Offline": "OFFLINE",
  "home-event-engage-OnOffline": "ON/OFFLINE",
  "home-event-none": "There are no registered events yet.",
  "home-event-all": "All Events",
  "home-event-info": "Event Information",
  "home-event-info-date": "Event Date",
  "home-event-info-period": "Registration Period",
  "home-event-info-location": "Location",
  "home-event-info-language": "Language",
  "common-share": "Share",
  "home-event-register": "Register",
  "home-event-speakers": "Speakers",
  "home-blog-title": "Codepresso Blog",
  "home-blog-count": "Blog Post | Blog Posts",
  "home-blog-none": "There are no registered blog posts yet.",
  "home-blog-all-post": "All Blog Posts",
  "home-blog-author": "By",
  "home-blog-about-codepresso": "About Codepresso",
  "home-blog-about-codepresso-description": "Codepresso offers an HR SaaS for organizations to quantify the skills of developers and empower skills-based digital talent management. With Codepresso, organizations can easily assess, diagnose, and hire the digital workforce and provide personalized upskilling/reskilling content. Throughout this process, all of the proficiency data collected enables organizations to make data-driven decisions.",
  "home-blog-about-codepresso-learn-more": "Learn more about Codepresso",
  "home-news-title": "Codepresso News",
  "home-news-count": "News",
  "home-news-none": "There is no news yet.",
  "home-news-topic": "News",
  "dashboard-my-profile": "See Profile",
  "account-profile": "Profile",
  "profile-private-info": "This information is private.",
  "profile-skill-none-data": "There are no skills written yet.",
  "profile-bios-none-data": "There are no bios written yet.",
  "profile-activity-history-none-data": "There are no activity history written yet.",
  "profile-work-experience-none-data": "There are no work experiences written yet.",
  "profile-education-none-data": "There is no education written yet.",
  "profile-edit": "Edit",
  "profile-image-upload-fail": "We couldn't upload your image. \nMake sure that your file is JPG, JPEG, PNG, or BMP.",
  "profile-change-success": "Your profile changes have been saved.",
  "profile-change-fail": "We couldn't save your profile changes. \nPlease try again.",
  "profile-private": "Private",
  "profile-public": "Public",
  "profile-private-change-success": "Your profile information is now private.",
  "profile-public-change-success": "Your profile information is now public.",
  "profile-job-offer": "Job Offer",
  "profile-job-offer-info": "Enable this setting to receive job offers.",
  "profile-add": "Add",
  "profile-headline": "Headline",
  "profile-headline-placeholder": "Enter a headline.",
  "profile-headline-error": "The headline must be less than 200 characters.",
  "profile-personal-info-title": "Personal Information",
  "profile-gender": "Gender",
  "profile-gender-drop-item-default": "Select your gender",
  "profile-gender-drop-item-male": "Male",
  "profile-gender-drop-item-female": "Female",
  "profile-gender-drop-item-other": "Other",
  "profile-gender-drop-item-not-say": "Prefer not to say",
  "profile-phone-number": "Phone Number",
  "profile-phone-number-placeholder": "Enter your phone number.",
  "profile-phone-number-error": "The phone number must be less than 25 characters.",
  "profile-links": "Links",
  "profile-links-error-linkedIn": "You must enter a valid LinkedIn URL.",
  "profile-links-error-gitHub": "You must enter a valid GitHub URL.",
  "profile-links-add": "Add Link",
  "profile-links-remove": "Are you sure you want to remove the link?",
  "profile-links-remove-success": "The link is successfully removed.",
  "profile-skills": "Skills",
  "profile-skills-search-placeholder": "Search by skills",
  "profile-skills-search-none": "Can't find {skill}? Would you like to add this skill?",
  "profile-skills-remove": "Are you sure you want to remove this skill?",
  "profile-skills-remove-success": "The skill is successfully removed.",
  "profile-about-me": "About Me",
  "profile-title": "Title",
  "profile-title-placeholder": "Enter a title.",
  "profile-title-error": "The title must be less than 50 characters.",
  "profile-content": "Content",
  "profile-content-placeholder": "Enter a content.",
  "profile-content-error": "The content must be less than 1500 characters.",
  "profile-about-me-delete": "Are you sure you want to delete this entry?",
  "profile-about-me-delete-success": "The entry is successfully deleted.",
  "profile-about-me-delete-fail": "We couldn't delete the entry.\nPlease try again.",
  "profile-activity-history": "Activity History",
  "profile-view-more": "View More",
  "profile-view-less": "View Less",
  "profile-work-experience": "Work Experience",
  "profile-work-experience-company-name": "Company Name",
  "profile-work-experience-company-name-placeholder": "Enter a company name.",
  "profile-work-experience-company-name-error": "The company name must be less than 50 characters.",
  "profile-work-experience-job-title": "Job Title",
  "profile-work-experience-job-title-placeholder": "Enter a job title.",
  "profile-work-experience-job-title-error": "The job title must be less than 50 characters.",
  "profile-work-experience-location": "Location",
  "profile-work-experience-location-placeholder": "Enter a location.",
  "profile-work-experience-location-error": "The location must be less than 150 characters.",
  "profile-work-experience-period": "Currently employed",
  "common-start-date": "Start Date",
  "common-month": "Month",
  "common-year": "Year",
  "common-end-date": "End Date",
  "profile-period-error": "The end date can't be earlier than the start date.",
  "profile-work-experience-description-placeholder": "Enter a description.",
  "profile-work-experience-description-error": "The description must be less than 1500 characters.",
  "profile-work-experience-entry-delete-title": "Are you sure you want to delete this entry?",
  "profile-work-experience-entry-delete-success": "The entry is successfully deleted.",
  "profile-work-experience-entry-delete-fail": "We couldn't delete the entry.\nPlease try again.",
  "profile-present": "Present",
  "profile-education": "Education",
  "profile-education-school-name": "School Name",
  "profile-education-school-name-placeholder": "Enter your school name.",
  "profile-education-school-name-error": "The school name must be less than 50 characters.",
  "profile-education-degree": "Degree",
  "profile-education-degree-placeholder": "Enter your degree.",
  "profile-education-degree-error": "The degree must be less than 50 characters.",
  "profile-education-major": "Major",
  "profile-education-major-placeholder": "Enter your major.",
  "profile-education-major-error": "The major must be less than 50 characters.",
  "profile-education-current-studying": "Currently studying here",
  "profile-education-delete-title": "Are you sure you want to delete this entry?",
  "profile-education-delete-success": "The entry is successfully deleted.",
  "profile-education-delete-fail": "We couldn't delete the entry.\nPlease try again.",
  "profile-access-limit": "You can't access this profile",
  "profile-access-limit-description": "The profile of a member who has deleted their account can't be viewed.",
  "advance-practice-assessment": "Practice Assessment",
  "learning-assessment-goal": "Goal of the practice assessment",
  "learning-assessment-goal-description": "We'd like to know how experienced you are with this track level.",
  "learning-assessment-evaluate": "Question Sets",
  "learning-assessment-evaluate-description": "The practice assessment consists of hands-on and multiple-choice questions.",
  "learning-assessment-how-to-complete": "How to complete",
  "learning-assessment-how-to-complete-description": "You must reach a passing score to pass the practice assessment.",
  "common-retake": "Retake",
  "learning-progress": "Progress",
  "learning-leave-warning-title": "Do you want to leave the assessment screen?",
  "learning-leave-warning-description": "Your submitted answers may not be saved.",
  "learning-leave": "Leave",
  "learning-finished-question": "Your answer has been submitted.",
  "learning-assessment-date": "Assessment Date",
  "learning-completed-banner": "You have completed this assessment",
  "learning-completed-success-description": "You passed the assessment by reaching a passing score.\nYou can now start a practice assessment for a new level or review the results of a practice assessment for a completed level.",
  "learning-completed-fail-description": "You didn't reach a passing score.\nPlease retake to pass the assessment.",
  "skillCertify-view-result": "View Results",
  "pricing-menu": "Pricing",
  "pricing-title": "Plans for Technical Skill Assessment",
  "pricing-content": "Choose the plan that suits your needs",
  "pricing-monthly": "Monthly",
  "pricing-annual": "Annually",
  "pricing-off": "{percent}% OFF",
  "pricing-basic": "Basic",
  "pricing-pro": "Pro",
  "pricing-enterprise": "Enterprise",
  "pricing-recommend": "Recommended",
  "pricing-year": "Year",
  "pricing-custom-pricing": "Custom Pricing",
  "pricing-basic-report": "Basic Report",
  "pricing-basic-skill-report": "Basic Skill Report",
  "pricing-report-language-single": "1 Language",
  "pricing-ai-assessment-recommendation-times": "AI-Tailored Assessment Recommendation {count} per month",
  "pricing-report-language-unlimited": "Unlimited Languages",
  "pricing-administrator-account-plural": "Unlimited Organization Administrators",
  "pricing-advanced-report": "Advanced Report",
  "pricing-advanced-skill-report": "Advanced Skill Report",
  "pricing-all-skill-assessments": "All Skill Assessments",
  "pricing-custom-questions": "Custom Question Design",
  "pricing-account-manager": "Account Manager",
  "pricing-ai-assessment-recommendation-unlimited": "Unlimited AI-Tailored Assessment Recommendation",
  "pricing-get-started": "Get Started",
  "pricing-coming-soon": "Coming Soon",
  "pricing-current-plan": "Current Plan",
  "pricing-upgrade": "Upgrade",
  "pricing-downgrade": "Downgrade",
  "pricing-compare-features-by-plan": "Compare Features by Plan",
  "pricing-feature": "Feature",
  "pricing-monthly-basic-assessment-invitation-credits": "Monthly Basic Credits (Non-Rollover)",
  "pricing-contract-terms": "Contract Terms",
  "pricing-purchase-additional-credits": "Purchase Additional Credits",
  "pricing-per-credit": "{price} per credit",
  "pricing-assessment-features": "Assessment Features",
  "pricing-create-basic-assessment": "Create Basic Assessment",
  "pricing-advanced-assessment": "Project Skill Assessment",
  "pricing-core-assessment": "Practical Skill Assessment",
  "pricing-ai-agent-assessment": "AI Utilization Skill Assessment",
  "pricing-core-assessment-description": "Core is a hands-on assessment that measures essential technical competencies in digital IT fields. By combining real-world scenario-based questions with practical assessments, it provides insights into an an individual's technical knowledge and their job-ready skills.",
  "pricing-advanced-assessment-description": "E2E simulates real-world project tasks in a hands-on environment to comprehensively assess developers' practical skills from design to implementation.",
  "pricing-ai-agent-assessment-description": "AI Fluent comprehensively assesses everything from AI utilization skills to an individual's AI governance capabilities based on real-world projects, and can be used to review an organization's AI-based development culture and derive directions for strengthening capabilities.",
  "pricing-core-assessment-filter-description": "Core is",
  "pricing-core-assessment-filter-description-1": " a hands-on assessment that measures essential technical competencies in digital IT fields. By combining real-world scenario-based questions with practical assessments, it provides insights into an an individual's technical knowledge and their job-ready skills.",
  "pricing-advanced-assessment-filter-description": "E2E",
  "pricing-advanced-assessment-filter-description-1": "simulates real-world project tasks in a hands-on environment to comprehensively assess developers' practical skills from design to implementation.",
  "pricing-ai-agent-assessment-filter-description": "AI Fluent",
  "pricing-ai-agent-assessment-filter-description-2": "comprehensively assesses everything from AI utilization skills to an individual's AI governance capabilities based on real-world projects, and can be used to review an organization's AI-based development culture and derive directions for strengthening capabilities.",
  "pricing-report-language": "Skill Report Language",
  "pricing-report-language-count-1": "1",
  "pricing-report-language-count-2": "No limit",
  "pricing-certificate-provided": "Skill Certificate",
  "pricing-ai-features": "AI Features",
  "pricing-report": "Skill Report",
  "pricing-ai-assessment-recommendation": "AI-Tailored Assessment Recommendation",
  "pricing-times-a-month": "{count} per month",
  "pricing-management-and-support": "Management and Support",
  "pricing-person": "1",
  "pricing-administrator": "Organization Administrator",
  "pricing-ats-integration": "Applicant Tracking System (ATS)",
  "pricing-to-be-added": "Upcoming feature",
  "pricing-basic-ats-provided": "Basic ATS Provided",
  "pricing-custom-integration": "Dedicated ATS Setup",
  "pricing-support": "Support",
  "pricing-faq": "FAQ",
  "pricing-faq-question-1": "Which plan should I choose?",
  "pricing-faq-question-1-answer-1": "You can select a plan based on your assessment operation needs and the level of features required.",
  "pricing-faq-question-1-answer-2": "Plan",
  "pricing-faq-question-1-answer-3": "Recommended For",
  "pricing-faq-question-1-answer-4": "Organizations that want to start technical skill assessments with basic proctoring and basic skill reports",
  "pricing-faq-question-1-answer-5": "Organizations that need enhanced assessment features such as advanced proctoring and project skill assessment",
  "pricing-faq-question-1-answer-6": "Organizations that need all skill assessments, dedicated ATS setup, and dedicated account manager support",
  "pricing-faq-question-2": "What are Credits?",
  "pricing-faq-question-2-answer-1": "Credits are used when inviting candidates to an assessment.",
  "pricing-faq-question-2-answer-2": "To run assessments, you'll need credits based on the number of candidates and assessment configuration.",
  "pricing-faq-question-3": "How many credits are used per candidate invitation?",
  "pricing-faq-question-3-answer-1": "For basic assessments, 1 credit is used per candidate.",
  "pricing-faq-question-3-answer-2": "However, additional credits may be used depending on the assessment configuration when enhanced assessment features such as project skill assessment are included.",
  "pricing-faq-question-4": "When are credits used?",
  "pricing-faq-question-4-answer-1": "When you invite candidates, credits will be used based on the number of candidates you invite and the assessment configuration.",
  "pricing-faq-question-4-answer-2": "If a candidate is deleted from the candidate list before starting the assessment, the credit used for that candidate will be refunded.",
  "pricing-faq-question-4-answer-3": "However, once a candidate starts the assessment, the credit used for that candidate can't be refunded.",
  "pricing-faq-question-5": "What happens when I use all my monthly basic credits?",
  "pricing-faq-question-5-answer-1": "If you've used all your monthly basic credits, you can top up credits to continue using assessments.",
  "pricing-faq-question-5-answer-2": "Only the Chief Organization Administrator can top up credits.",
  "pricing-faq-question-5-answer-3": "Charged credits have no expiration date, but can only be charged and used while subscribed.",
  "pricing-faq-question-5-answer-4": "However, the Enterprise plan is operated under separate contract terms, so a separate inquiry is required if you need to top up credits.",
  "pricing-faq-question-6": "What happens if payment fails due to card expiration, etc.?",
  "pricing-faq-question-6-answer-1": "If the payment fails, a notification email will be sent to the Chief Organization Administrator's email address.",
  "pricing-faq-question-6-answer-2": "Automatic payment retries may occur up to 3 times after payment failure.",
  "pricing-faq-question-6-answer-3": "If payment continues to fail, automatic payment retries will stop, and your subscription will end.",
  "pricing-faq-question-7": "What happens when I cancel my subscription?",
  "pricing-faq-question-7-answer-1": "When you cancel your subscription, automatic payments will stop from the next payment date.",
  "pricing-faq-question-7-answer-2": "If you have a remaining paid subscription period, you can continue to use your current plan for that duration.",
  "pricing-faq-question-7-answer-3": "When your subscription ends, any charged credits you have will also become unusable. You can use them again by restarting your subscription.",
  "pricing-faq-question-8": "Is a refund available?",
  "pricing-faq-question-8-answer-1": "In principle, payment amounts for subscription plans and charged credits are non-refundable.",
  "pricing-faq-question-8-answer-2": "However, refunds may be considered in exceptional circumstances where the company is at fault or refunds are required by applicable law.",
  "pricing-faq-question-8-answer-3": "Please refer to the {link} for details.",
  "pricing-faq-question-9": "What criteria are used to calculate the refund amount, and how can I request a refund?",
  "pricing-faq-question-9-answer-1": "In exceptional cases where a refund is approved, the refund amount will be based on the actual payment amount (including taxes).",
  "pricing-faq-question-9-answer-2": "The refund amount does not include discounts applied through coupons or promotions.",
  "pricing-faq-question-9-answer-3": "For refund inquiries, you can submit a request through the Contact Us icon (Channel Talk) at the bottom of the screen or email us at {link1}.\nWe will review your request and inform you of your refund eligibility and the final refund amount.",
  "pricing-info-1-title": "Subscription plans are available for organizational accounts only",
  "pricing-info-2-title": "To use a subscription plan, you must first create an organization",
  "pricing-info-2-description": "Go to Organization Settings",
  "pricing-info-3-title": "Only the Chief Organization Administrator can proceed with the subscription payments",
  "payment-payment-information": "Payment Information",
  "payment-organization-information": "Organization Information",
  "payment-payment-method": "Payment Method",
  "payment-cardholder-name": "Name on card",
  "payment-card-number": "Card Number",
  "payment-expiration-date": "Expiration Date",
  "payment-security-code": "Security Code",
  "payment-product-price": "Product Price",
  "payment-coupon-discount": "Coupon Discount",
  "payment-select-coupon": "Select Coupon",
  "payment-coupon-discount-amount": "Coupon Discount Amount",
  "payment-cancel-coupon": "Remove Coupon",
  "payment-estimated-payment-amount": "Estimated Payment Amount",
  "payment-tax-description": "Taxes are calculated at checkout.",
  "payment-agree-all-check": "I agree to all.",
  "payment-agree-required": "Required",
  "payment-agree-check-1": "I agree to {policy} and {term}.",
  "payment-agree-check-2": "I agree to automatic subscription renewal and saving my payment method for billing.",
  "payment-subscribe": "Subscribe",
  "payment-subscribe-processing": "Processing",
  "payment-subscribe-info-1": "Automatically billed based on your billing cycle.",
  "payment-subscribe-info-2": "If the payment date falls on a day that doesn't exist in a given month (e.g., the 31st), payment will be processed on the last day of that month.",
  "payment-cardholder-name-error-1": "Enter the name on card.",
  "payment-cardholder-name-error-2": "The name on card must be between 1 and 20 characters.",
  "payment-card-number-error-1": "Enter the card number.",
  "payment-card-number-error-2": "Please check the card number again.",
  "payment-expiration-date-error-1": "Enter the expiration date.",
  "payment-expiration-date-error-2": "Please check the expiration date again.",
  "payment-security-code-error-1": "Enter the security code.",
  "payment-security-code-error-2": "Please check the security code again.",
  "payment-coupon": "Coupon",
  "payment-my-coupons": "My Coupons",
  "payment-annual-billing-only": "Annual billing only",
  "payment-monthly-subscription-only": "Monthly billing only",
  "payment-first-purchase-only": "First purchase only",
  "payment-benefits": "Benefits",
  "payment-validity-period": "Validity Period",
  "payment-days-left": "00 Days Left",
  "payment-coupon-applied-success": "The coupon has been applied.",
  "payment-coupon-applied-fail": "We couldn't apply the coupon.\nPlease try again.",
  "payment-register-coupon": "Add Coupon",
  "payment-coupon-code": "Coupon Code",
  "payment-coupon-code-placeholder": "Enter the coupon code.",
  "payment-coupon-code-error": "The coupon code is not valid.",
  "payment-coupon-code-success": "The coupon has been added.",
  "payment-coupon-code-fail": "We couldn't add the coupon.\nPlease try again.",
  "payment-agree-required-error": "Please agree to the required items.",
  "payment-error-title": "The payment has failed",
  "payment-error-contents": "Please check the card details you entered and try again.\nIf the payment continues to fail, please use a different card or contact the card issuer.\nIf the problem persists, please contact us via the {contact} menu.",
  "payment-error-contents-2": "Please try again.\nIf the payment continues to fail, please use a different card or contact the card issuer.\nIf the problem persists, please contact us via the {contact} menu.",
  "payment-payment-method-none": "No payment method has been registered yet.",
  "payment-payment-method-register": "Register Payment Method",
  "payment-payment-method-register-success": "The payment method registration has been completed.",
  "payment-payment-method-register-fail-title": "The payment method registration has failed",
  "payment-payment-method-register-fail-contents": "Please check the card details and try again.\nIf the payment continues to fail, please use a different card or contact the card issuer.\nIf the problem persists, please contact us via the {contact} menu.",
  "payment-payment-method-change-fail-title": "Failed to change the payment method",
  "payment-complete-title": "Payment Completed",
  "payment-complete-payment-history": "Payment History",
  "payment-complete-payment-date": "Payment Date",
  "payment-complete-payment-amount": "Payment Amount",
  "payment-complete-view-invoice": "View Invoice",
  "payment-complete-next-billing-date": "Next Payment Date",
  "payment-complete-description": "Check your {payment} for details.",
  "payment-complete-button": "Go to Subscription Management",
  "learning-away-with-out-title": "Do you want to leave without submitting your answers?",
  "learning-away-with-out-description": "We recommend submitting your answers to save them before leaving.\nIf you make any additional changes after submitting, you can resubmit.",
  "learning-away-with-out-leave": "Leave without submitting",
  "learning-away-with-out-stay": "Stay",
  "skillCertify-locale-change-away-with-out-title": "Do you want to change the language without saving your answers?",
  "skillCertify-locale-change-away-with-out-description": "We recommend submitting your answers to save them before changing the language.\nIf you make any additional changes after submitting, you can resubmit.",
  "skillCertify-locale-change-away-with-out": "Change without saving",
  "terms-agree-title": "",
  "terms-agree-check-1": "",
  "terms-agree-check-2": "",
  "terms-agree-check-3": "",
  "skillCertify-not-participated": "",
  "skillCertify-no-show": "",
  "skillCertify-candidate-no-show-date": "",
  "skillCertify-proctoring-program-currently-running-title": "",
  "skillCertify-proctoring-program-currently-running-description": "",
  "skillCertify-close-proctoring-program-title": "",
  "skillCertify-close-proctoring-program-description": "",
  "skillCertify-close-proctoring-program-button": "",
  "skillCertify-proctoring-face-voice-recording-set-up-camera-no-use": "",
  "skillCertify-proctoring-face-voice-recording-set-up-camera-check-required": "",
  "skillCertify-proctoring-face-voice-recording-set-up-microphone-check-required": "",
  "skillCertify-assessment-completed-close-proctoring-program": "",
  "skillMonitor-track-summary-table-all-average-score": "",
  "skillMonitor-all-candidates-based-info": "",
  "skillMonitor-all-candidates-based-info-median": "",
  "skillMonitor-track-summary-table-all-average-skill-rate": "",
  "skillMonitor-candidate-sw-quality-analysis-info": "",
  "skillMonitor-candidate-code-quality-summary-result": "",
  "skillMonitor-candidate-code-quality-grade": "",
  "skillMonitor-candidate-code-quality-details": "",
  "skillMonitor-candidate-code-button": "",
  "skillMonitor-static-analysis-metrics": "",
  "skillMonitor-static-analysis": "",
  "skillMonitor-analysis-severity-medium": "",
  "skillMonitor-candidate-architecture-quality-summary-result": "",
  "skillMonitor-candidate-architecture-quality-grade": "",
  "skillMonitor-candidate-architecture-quality-details": "",
  "user-grades-type-chief-admin": "",
  "home-faq-helpcenter": "",
  "home-faq-hero-title": "",
  "home-faq-search-placeholder": "",
  "home-faq-search-result-count": "",
  "home-faq-help-count": "",
  "home-faq-admin-category-credit": "",
  "home-faq-admin-category-candidate-manage": "",
  "home-faq-admin-category-report": "",
  "home-faq-admin-category-skillfit-ops": "",
  "home-faq-admin-category-org-role": "",
  "home-faq-admin-category-security": "",
  "home-faq-tab-user": "",
  "home-faq-user-category-invite-start": "",
  "home-faq-user-category-check": "",
  "home-faq-user-category-proctor": "",
  "home-faq-user-category-result": "",
  "home-faq-user-category-skillfit": "",
  "home-faq-user-category-troubleshoot": "",
  "home-faq-bottom-title": "",
  "home-faq-bottom-description": "",
  "home-faq-admin-getting-started-question-1": "",
  "home-faq-admin-getting-started-question-1-answer-1": "",
  "home-faq-admin-getting-started-question-1-answer-2": "",
  "home-faq-admin-getting-started-question-1-answer-3": "",
  "home-faq-admin-getting-started-question-1-answer-4": "",
  "home-faq-admin-getting-started-question-1-answer-5": "",
  "home-faq-admin-getting-started-question-2": "",
  "home-faq-admin-getting-started-question-2-answer-1": "",
  "home-faq-admin-getting-started-question-2-answer-2": "",
  "home-faq-admin-getting-started-question-3": "",
  "home-faq-admin-getting-started-question-3-answer-1": "",
  "home-faq-admin-getting-started-question-3-answer-2": "",
  "home-faq-admin-getting-started-question-3-answer-3": "",
  "home-faq-admin-getting-started-question-4": "",
  "home-faq-admin-getting-started-question-4-answer-1": "",
  "home-faq-admin-getting-started-question-4-answer-2": "",
  "home-faq-admin-getting-started-question-5": "",
  "home-faq-admin-getting-started-question-5-answer-1": "",
  "home-faq-admin-getting-started-question-5-answer-2": "",
  "home-faq-admin-getting-started-question-5-answer-3": "",
  "home-faq-admin-getting-started-question-5-answer-4": "",
  "home-faq-admin-getting-started-question-5-answer-5": "",
  "home-faq-admin-getting-started-question-5-answer-6": "",
  "home-faq-admin-getting-started-question-5-answer-7": "",
  "home-faq-admin-credit-question-1": "",
  "home-faq-admin-credit-question-1-answer-1": "",
  "home-faq-admin-credit-question-1-answer-2": "",
  "home-faq-admin-credit-question-1-answer-3": "",
  "home-faq-admin-credit-question-1-answer-4": "",
  "home-faq-admin-credit-question-2": "",
  "home-faq-admin-credit-question-2-answer-1": "",
  "home-faq-admin-credit-question-2-answer-2": "",
  "home-faq-admin-credit-question-2-answer-3": "",
  "home-faq-admin-org-role-question-1": "",
  "home-faq-admin-org-role-question-1-answer-1": "",
  "home-faq-admin-org-role-question-1-answer-2": "",
  "home-faq-admin-org-role-question-1-answer-3": "",
  "home-faq-admin-org-role-question-1-answer-4": "",
  "home-faq-admin-org-role-question-1-answer-5": "",
  "home-faq-admin-org-role-question-1-answer-6": "",
  "home-faq-admin-org-role-question-1-answer-7": "",
  "home-faq-admin-org-role-question-1-answer-8": "",
  "home-faq-admin-org-role-question-1-answer-9": "",
  "home-faq-admin-org-role-question-1-answer-10": "",
  "home-faq-admin-org-role-question-1-answer-11": "",
  "home-faq-admin-org-role-question-2": "",
  "home-faq-admin-org-role-question-2-answer-1": "",
  "home-faq-admin-org-role-question-2-answer-2": "",
  "home-faq-admin-org-role-question-2-answer-3": "",
  "home-faq-admin-org-role-question-2-answer-4": "",
  "home-faq-admin-org-role-question-2-answer-5": "",
  "home-faq-admin-org-role-question-2-answer-6": "",
  "home-faq-admin-org-role-question-2-answer-7": "",
  "home-faq-admin-org-role-question-3": "",
  "home-faq-admin-org-role-question-3-answer-1": "",
  "home-faq-admin-org-role-question-3-answer-2": "",
  "home-faq-admin-org-role-question-4": "",
  "home-faq-admin-org-role-question-4-answer-1": "",
  "home-faq-admin-org-role-question-4-answer-2": "",
  "home-faq-admin-org-role-question-5": "",
  "home-faq-admin-org-role-question-5-answer-1": "",
  "home-faq-admin-org-role-question-5-answer-2": "",
  "home-faq-admin-org-role-question-5-answer-3": "",
  "home-faq-admin-org-role-question-5-answer-4": "",
  "home-faq-admin-org-role-question-6": "",
  "home-faq-admin-org-role-question-6-answer-1": "",
  "home-faq-admin-org-role-question-6-answer-2": "",
  "home-faq-admin-org-role-question-6-answer-3": "",
  "home-faq-admin-org-role-question-6-answer-4": "",
  "home-faq-admin-org-role-question-7": "",
  "home-faq-admin-org-role-question-7-answer-1": "",
  "home-faq-admin-org-role-question-7-answer-2": "",
  "home-faq-admin-assessment-create-question-1": "",
  "home-faq-admin-assessment-create-question-1-answer-1": "",
  "home-faq-admin-assessment-create-question-1-answer-2": "",
  "home-faq-admin-assessment-create-question-1-answer-3": "",
  "home-faq-admin-assessment-create-question-1-answer-4": "",
  "home-faq-admin-assessment-create-question-1-answer-5": "",
  "home-faq-admin-assessment-create-question-1-answer-6": "",
  "home-faq-admin-assessment-create-question-1-answer-7": "",
  "home-faq-admin-assessment-create-question-1-answer-8": "",
  "home-faq-admin-assessment-create-question-1-answer-9": "",
  "home-faq-admin-assessment-create-question-1-answer-10": "",
  "home-faq-admin-assessment-create-question-1-answer-11": "",
  "home-faq-admin-assessment-create-question-1-answer-12": "",
  "home-faq-admin-assessment-create-question-1-answer-13": "",
  "home-faq-admin-assessment-create-question-1-answer-14": "",
  "home-faq-admin-assessment-create-question-2": "",
  "home-faq-admin-assessment-create-question-2-answer-1": "",
  "home-faq-admin-assessment-create-question-2-answer-2": "",
  "home-faq-admin-assessment-create-question-2-answer-3": "",
  "home-faq-admin-assessment-create-question-2-answer-4": "",
  "home-faq-admin-assessment-create-question-2-answer-5": "",
  "home-faq-admin-assessment-create-question-3": "",
  "home-faq-admin-assessment-create-question-3-answer-1": "",
  "home-faq-admin-assessment-create-question-3-answer-2": "",
  "home-faq-admin-assessment-create-question-4": "",
  "home-faq-admin-assessment-create-question-4-answer-1": "",
  "home-faq-admin-assessment-create-question-4-answer-2": "",
  "home-faq-admin-assessment-create-question-4-answer-3": "",
  "home-faq-admin-assessment-create-question-4-answer-4": "",
  "home-faq-admin-assessment-create-question-4-answer-5": "",
  "home-faq-admin-assessment-create-question-4-answer-6": "",
  "home-faq-admin-assessment-create-question-4-answer-7": "",
  "home-faq-admin-assessment-create-question-4-answer-8": "",
  "home-faq-admin-assessment-create-question-5": "",
  "home-faq-admin-assessment-create-question-5-answer-1": "",
  "home-faq-admin-assessment-create-question-5-answer-2": "",
  "home-faq-admin-assessment-create-question-5-answer-3": "",
  "home-faq-admin-assessment-create-question-5-answer-4": "",
  "home-faq-admin-assessment-create-question-5-answer-5": "",
  "home-faq-admin-assessment-create-question-5-answer-6": "",
  "home-faq-admin-assessment-create-question-5-answer-7": "",
  "home-faq-admin-assessment-create-question-6": "",
  "home-faq-admin-assessment-create-question-6-answer-1": "",
  "home-faq-admin-assessment-create-question-6-answer-2": "",
  "home-faq-admin-assessment-create-question-6-answer-3": "",
  "home-faq-admin-assessment-create-question-6-answer-4": "",
  "home-faq-admin-assessment-create-question-6-answer-5": "",
  "home-faq-admin-assessment-create-question-6-answer-6": "",
  "home-faq-admin-assessment-create-question-6-answer-7": "",
  "home-faq-admin-assessment-create-question-6-answer-8": "",
  "home-faq-admin-assessment-create-question-6-answer-9": "",
  "home-faq-admin-assessment-create-question-6-answer-10": "",
  "home-faq-admin-assessment-create-question-7": "",
  "home-faq-admin-assessment-create-question-7-answer-1": "",
  "home-faq-admin-assessment-create-question-7-answer-2": "",
  "home-faq-admin-assessment-create-question-7-answer-3": "",
  "home-faq-admin-assessment-create-question-7-answer-4": "",
  "home-faq-admin-assessment-create-question-8": "",
  "home-faq-admin-assessment-create-question-8-answer-1": "",
  "home-faq-admin-assessment-create-question-8-answer-2": "",
  "home-faq-admin-assessment-create-question-8-answer-3": "",
  "home-faq-admin-assessment-create-question-8-answer-4": "",
  "home-faq-admin-assessment-create-question-9": "",
  "home-faq-admin-assessment-create-question-9-answer-1": "",
  "home-faq-admin-assessment-create-question-9-answer-2": "",
  "home-faq-admin-assessment-create-question-9-answer-3": "",
  "home-faq-admin-assessment-create-question-9-answer-4": "",
  "home-faq-admin-assessment-create-question-9-answer-5": "",
  "home-faq-admin-assessment-create-question-9-answer-6": "",
  "home-faq-admin-assessment-create-question-9-answer-7": "",
  "home-faq-admin-assessment-create-question-9-answer-8": "",
  "home-faq-admin-assessment-create-question-9-answer-9": "",
  "home-faq-admin-assessment-create-question-9-answer-10": "",
  "home-faq-admin-assessment-create-question-9-answer-11": "",
  "home-faq-admin-assessment-create-question-9-answer-12": "",
  "home-faq-admin-assessment-create-question-9-answer-13": "",
  "home-faq-admin-assessment-create-question-10": "",
  "home-faq-admin-assessment-create-question-10-answer-1": "",
  "home-faq-admin-assessment-create-question-10-answer-2": "",
  "home-faq-admin-candidate-manage-question-1": "",
  "home-faq-admin-candidate-manage-question-1-answer-1": "",
  "home-faq-admin-candidate-manage-question-1-answer-2": "",
  "home-faq-admin-candidate-manage-question-1-answer-3": "",
  "home-faq-admin-candidate-manage-question-1-answer-4": "",
  "home-faq-admin-candidate-manage-question-1-answer-5": "",
  "home-faq-admin-candidate-manage-question-1-answer-6": "",
  "home-faq-admin-candidate-manage-question-1-answer-7": "",
  "home-faq-admin-candidate-manage-question-1-answer-8": "",
  "home-faq-admin-candidate-manage-question-1-answer-9": "",
  "home-faq-admin-candidate-manage-question-2": "",
  "home-faq-admin-candidate-manage-question-2-answer-1": "",
  "home-faq-admin-candidate-manage-question-2-answer-2": "",
  "home-faq-admin-candidate-manage-question-2-answer-3": "",
  "home-faq-admin-candidate-manage-question-2-answer-4": "",
  "home-faq-admin-candidate-manage-question-3": "",
  "home-faq-admin-candidate-manage-question-3-answer-1": "",
  "home-faq-admin-candidate-manage-question-3-answer-2": "",
  "home-faq-admin-candidate-manage-question-3-answer-3": "",
  "home-faq-admin-candidate-manage-question-3-answer-4": "",
  "home-faq-admin-candidate-manage-question-3-answer-5": "",
  "home-faq-admin-candidate-manage-question-3-answer-6": "",
  "home-faq-admin-candidate-manage-question-3-answer-7": "",
  "home-faq-admin-candidate-manage-question-3-answer-8": "",
  "home-faq-admin-candidate-manage-question-4": "",
  "home-faq-admin-candidate-manage-question-4-answer-1": "",
  "home-faq-admin-candidate-manage-question-4-answer-2": "",
  "home-faq-admin-candidate-manage-question-4-answer-3": "",
  "home-faq-admin-candidate-manage-question-4-answer-4": "",
  "home-faq-admin-candidate-manage-question-5": "",
  "home-faq-admin-candidate-manage-question-5-answer-1": "",
  "home-faq-admin-candidate-manage-question-5-answer-2": "",
  "home-faq-admin-candidate-manage-question-5-answer-3": "",
  "home-faq-admin-candidate-manage-question-5-answer-4": "",
  "home-faq-admin-candidate-manage-question-6": "",
  "home-faq-admin-candidate-manage-question-6-answer-1": "",
  "home-faq-admin-candidate-manage-question-6-answer-2": "",
  "home-faq-admin-candidate-manage-question-6-answer-3": "",
  "home-faq-admin-report-question-1": "",
  "home-faq-admin-report-question-1-answer-1": "",
  "home-faq-admin-report-question-1-answer-2": "",
  "home-faq-admin-report-question-1-answer-3": "",
  "home-faq-admin-report-question-1-answer-4": "",
  "home-faq-admin-report-question-2": "",
  "home-faq-admin-report-question-2-answer-1": "",
  "home-faq-admin-report-question-2-answer-2": "",
  "home-faq-admin-report-question-2-answer-3": "",
  "home-faq-admin-report-question-2-answer-4": "",
  "home-faq-admin-report-question-2-answer-5": "",
  "home-faq-admin-report-question-2-answer-6": "",
  "home-faq-admin-report-question-2-answer-7": "",
  "home-faq-admin-report-question-2-answer-8": "",
  "home-faq-admin-report-question-2-answer-9": "",
  "home-faq-admin-report-question-2-answer-10": "",
  "home-faq-admin-report-question-3": "",
  "home-faq-admin-report-question-3-answer-1": "",
  "home-faq-admin-report-question-3-answer-2": "",
  "home-faq-admin-report-question-4": "",
  "home-faq-admin-report-question-4-answer-1": "",
  "home-faq-admin-report-question-4-answer-2": "",
  "home-faq-admin-report-question-5": "",
  "home-faq-admin-report-question-5-answer-1": "",
  "home-faq-admin-report-question-6": "",
  "home-faq-admin-report-question-6-answer-1": "",
  "home-faq-admin-report-question-6-answer-2": "",
  "home-faq-admin-skillfit-ops-question-1": "",
  "home-faq-admin-skillfit-ops-question-1-answer-1": "",
  "home-faq-admin-skillfit-ops-question-1-answer-2": "",
  "home-faq-admin-skillfit-ops-question-2": "",
  "home-faq-admin-skillfit-ops-question-2-answer-1": "",
  "home-faq-admin-skillfit-ops-question-2-answer-2": "",
  "home-faq-admin-skillfit-ops-question-2-answer-3": "",
  "home-faq-admin-skillfit-ops-question-2-answer-4": "",
  "home-faq-admin-skillfit-ops-question-2-answer-5": "",
  "home-faq-admin-security-question-1": "",
  "home-faq-admin-security-question-1-answer-1": "",
  "home-faq-admin-security-question-1-answer-2": "",
  "home-faq-admin-security-question-2": "",
  "home-faq-admin-security-question-2-answer-1": "",
  "home-faq-admin-security-question-2-answer-2": "",
  "home-faq-user-invite-start-question-1": "",
  "home-faq-user-invite-start-question-1-answer-1": "",
  "home-faq-user-invite-start-question-1-answer-2": "",
  "home-faq-user-invite-start-question-1-answer-3": "",
  "home-faq-user-invite-start-question-1-answer-4": "",
  "home-faq-user-invite-start-question-1-answer-5": "",
  "home-faq-user-invite-start-question-1-answer-6": "",
  "home-faq-user-invite-start-question-1-answer-7": "",
  "home-faq-user-invite-start-question-1-answer-8": "",
  "home-faq-user-invite-start-question-1-answer-9": "",
  "home-faq-user-invite-start-question-2-answer-1": "",
  "home-faq-user-invite-start-question-2-answer-2": "",
  "home-faq-user-invite-start-question-2-answer-3": "",
  "home-faq-user-invite-start-question-2-answer-4": "",
  "home-faq-user-invite-start-question-2-answer-5": "",
  "home-faq-user-invite-start-question-3-answer-1": "",
  "home-faq-user-invite-start-question-3-answer-2": "",
  "home-faq-user-invite-start-question-3-answer-3": "",
  "home-faq-user-invite-start-question-4": "",
  "home-faq-user-invite-start-question-4-answer-1": "",
  "home-faq-user-invite-start-question-4-answer-2": "",
  "home-faq-user-invite-start-question-4-answer-3": "",
  "home-faq-user-invite-start-question-4-answer-4": "",
  "home-faq-user-invite-start-question-5": "",
  "home-faq-user-invite-start-question-5-answer-1": "",
  "home-faq-user-invite-start-question-5-answer-2": "",
  "home-faq-user-invite-start-question-5-answer-3": "",
  "home-faq-user-invite-start-question-5-answer-4": "",
  "home-faq-user-invite-start-question-6": "",
  "home-faq-user-invite-start-question-6-answer-1": "",
  "home-faq-user-invite-start-question-6-answer-2": "",
  "home-faq-user-invite-start-question-6-answer-3": "",
  "home-faq-user-invite-start-question-6-answer-4": "",
  "home-faq-user-check-question-1": "",
  "home-faq-user-check-question-1-answer-1": "",
  "home-faq-user-check-question-1-answer-2": "",
  "home-faq-user-check-question-1-answer-3": "",
  "home-faq-user-check-question-2": "",
  "home-faq-user-check-question-2-answer-1": "",
  "home-faq-user-check-question-2-answer-2": "",
  "home-faq-user-check-question-2-answer-3": "",
  "home-faq-user-check-question-2-answer-4": "",
  "home-faq-user-check-question-2-answer-5": "",
  "home-faq-user-check-question-2-answer-6": "",
  "home-faq-user-check-question-3": "",
  "home-faq-user-check-question-3-answer-1": "",
  "home-faq-user-check-question-3-answer-2": "",
  "home-faq-user-check-question-4": "",
  "home-faq-user-check-question-4-answer-1": "",
  "home-faq-user-check-question-4-answer-2": "",
  "home-faq-user-check-question-5": "",
  "home-faq-user-check-question-5-answer-1": "",
  "home-faq-user-check-question-5-answer-2": "",
  "home-faq-user-assessment-take-question-1": "",
  "home-faq-user-assessment-take-question-1-answer-1": "",
  "home-faq-user-assessment-take-question-1-answer-2": "",
  "home-faq-user-assessment-take-question-1-answer-3": "",
  "home-faq-user-assessment-take-question-1-answer-4": "",
  "home-faq-user-assessment-take-question-1-answer-5": "",
  "home-faq-user-assessment-take-question-2": "",
  "home-faq-user-assessment-take-question-2-answer-1": "",
  "home-faq-user-assessment-take-question-2-answer-2": "",
  "home-faq-user-assessment-take-question-2-answer-3": "",
  "home-faq-user-assessment-take-question-3": "",
  "home-faq-user-assessment-take-question-3-answer-1": "",
  "home-faq-user-assessment-take-question-3-answer-2": "",
  "home-faq-user-assessment-take-question-3-answer-3": "",
  "home-faq-user-assessment-take-question-3-answer-4": "",
  "home-faq-user-assessment-take-question-3-answer-5": "",
  "home-faq-user-assessment-take-question-4": "",
  "home-faq-user-assessment-take-question-4-answer-1": "",
  "home-faq-user-assessment-take-question-4-answer-2": "",
  "home-faq-user-assessment-take-question-4-answer-3": "",
  "home-faq-user-assessment-take-question-4-answer-4": "",
  "home-faq-user-assessment-take-question-5": "",
  "home-faq-user-assessment-take-question-5-answer-1": "",
  "home-faq-user-assessment-take-question-5-answer-2": "",
  "home-faq-user-assessment-take-question-6": "",
  "home-faq-user-assessment-take-question-6-answer-1": "",
  "home-faq-user-assessment-take-question-6-answer-2": "",
  "home-faq-user-assessment-take-question-6-answer-3": "",
  "home-faq-user-assessment-take-question-7": "",
  "home-faq-user-assessment-take-question-7-answer-1": "",
  "home-faq-user-assessment-take-question-7-answer-2": "",
  "home-faq-user-assessment-take-question-8": "",
  "home-faq-user-assessment-take-question-8-answer-1": "",
  "home-faq-user-assessment-take-question-8-answer-2": "",
  "home-faq-user-assessment-take-question-9": "",
  "home-faq-user-assessment-take-question-9-answer-1": "",
  "home-faq-user-assessment-take-question-9-answer-2": "",
  "home-faq-user-assessment-take-question-10": "",
  "home-faq-user-assessment-take-question-10-answer-1": "",
  "home-faq-user-assessment-take-question-10-answer-2": "",
  "home-faq-user-proctor-question-1": "",
  "home-faq-user-proctor-question-1-answer-1": "",
  "home-faq-user-proctor-question-1-answer-2": "",
  "home-faq-user-proctor-question-1-answer-3": "",
  "home-faq-user-proctor-question-1-answer-4": "",
  "home-faq-user-proctor-question-2": "",
  "home-faq-user-proctor-question-2-answer-1": "",
  "home-faq-user-proctor-question-2-answer-2": "",
  "home-faq-user-proctor-question-2-answer-3": "",
  "home-faq-user-proctor-question-2-answer-4": "",
  "home-faq-user-proctor-question-2-answer-5": "",
  "home-faq-user-proctor-question-2-answer-6": "",
  "home-faq-user-proctor-question-3": "",
  "home-faq-user-proctor-question-3-answer-1": "",
  "home-faq-user-proctor-question-3-answer-2": "",
  "home-faq-user-proctor-question-3-answer-3": "",
  "home-faq-user-proctor-question-3-answer-4": "",
  "home-faq-user-proctor-question-3-answer-5": "",
  "home-faq-user-proctor-question-4": "",
  "home-faq-user-proctor-question-4-answer-1": "",
  "home-faq-user-proctor-question-4-answer-2": "",
  "home-faq-user-proctor-question-5": "",
  "home-faq-user-proctor-question-5-answer-1": "",
  "home-faq-user-proctor-question-5-answer-2": "",
  "home-faq-user-result-question-1": "",
  "home-faq-user-result-question-1-answer-1": "",
  "home-faq-user-result-question-1-answer-2": "",
  "home-faq-user-result-question-1-answer-3": "",
  "home-faq-user-result-question-1-answer-4": "",
  "home-faq-user-result-question-1-answer-5": "",
  "home-faq-user-result-question-2": "",
  "home-faq-user-result-question-2-answer-1": "",
  "home-faq-user-result-question-3": "",
  "home-faq-user-result-question-3-answer-1": "",
  "home-faq-user-skillfit-question-1-answer-1": "",
  "home-faq-user-skillfit-question-1-answer-2": "",
  "home-faq-user-skillfit-question-1-answer-3": "",
  "home-faq-user-skillfit-question-2": "",
  "home-faq-user-skillfit-question-2-answer-1": "",
  "home-faq-user-skillfit-question-2-answer-2": "",
  "home-faq-user-skillfit-question-2-answer-3": "",
  "home-faq-user-skillfit-question-2-answer-4": "",
  "home-faq-user-skillfit-question-3": "",
  "home-faq-user-skillfit-question-3-answer-1": "",
  "home-faq-user-skillfit-question-3-answer-2": "",
  "home-faq-user-skillfit-question-3-answer-3": "",
  "home-faq-user-troubleshoot-question-1": "",
  "home-faq-user-troubleshoot-question-1-answer-1": "",
  "home-faq-user-troubleshoot-question-1-answer-2": "",
  "home-faq-user-troubleshoot-question-1-answer-3": "",
  "home-faq-user-troubleshoot-question-2": "",
  "home-faq-user-troubleshoot-question-2-answer-1": "",
  "home-faq-user-troubleshoot-question-2-answer-2": "",
  "home-faq-user-troubleshoot-question-3": "",
  "home-faq-user-troubleshoot-question-3-answer-1": "",
  "home-faq-user-troubleshoot-question-3-answer-2": "",
  "home-faq-user-troubleshoot-question-3-answer-3": "",
  "home-faq-user-troubleshoot-question-3-answer-4": "",
  "home-faq-user-troubleshoot-question-4": "",
  "home-faq-user-troubleshoot-question-4-answer-1": "",
  "home-faq-user-troubleshoot-question-4-answer-2": "",
  "home-faq-user-troubleshoot-question-5": "",
  "home-faq-user-troubleshoot-question-5-answer-1": ""
};